// import { Printer } from '@awesome-cordova-plugins/printer';
import { Toast } from '@capacitor/toast';
import { IonActionSheet, IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonChip, IonCol, IonContent, IonFab, IonFabButton, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonPage, IonPopover, IonRadio, IonRadioGroup, IonReorder, IonReorderGroup, IonRow, IonSearchbar, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonTextarea, IonTitle, IonToast, IonToggle, IonToolbar, isPlatform, ItemReorderEventDetail, useIonAlert, useIonViewDidEnter } from '@ionic/react';
import imageCompression from 'browser-image-compression';
import { add, addCircle, addOutline, appsOutline, arrowBack, bagHandleOutline, book, bookOutline, calendarOutline, cameraOutline, cashOutline, closeOutline, cogOutline, colorPaletteOutline, copy, copyOutline, cubeOutline, documentTextOutline, downloadOutline, ellipsisVertical, fastFoodOutline, informationCircleOutline, listOutline, pencilOutline, printOutline, qrCodeOutline, removeCircle, reorderTwo, searchOutline, sparklesOutline, star, storefrontOutline, timeOutline, trashOutline } from 'ionicons/icons';
import QRCode from 'qrcode';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
// import { v4 as uuidv4 } from 'uuid';
import { Buffer } from 'buffer';
import { alterarCorCatalogoDigital, alterarItemCatalogoProdutosEmpresa, assinaUrl, empresaCarregar, fiscalListarCategorias, inserirItemCatalogoProdutosEmpresa, onboardingAtualizarEtapa, ordernarItemCatalogoProdutosEmpresa, removerItemCatalogoProdutosEmpresa, requestService } from '../../../../../Utils/Services';
import OnboardingContextBanner from '../../../../../components/Onboarding/OnboardingContextBanner';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { OnboardingContext } from '../../../../../contexts/OnboardingContext';
import UploadAnotaAi from '../UploadAnotaAi/UploadAnotaAi';
import UploadEcta from '../UploadEcta/UploadEcta';
import UploadGoomer from '../UploadGoomer/UploadGoomer';
import UploadIfood from '../UploadIfood/UploadIfood';
import UploadInstaDelivery from '../UploadInstaDelivery/UploadInstaDelivery';
// import UploadKivoPedidos from '../UploadKivoPedidos/UploadKivoPedidos';
import UploadIA from '../UploadIA/UploadIA';
import UploadWhatsMenu from '../UploadWhatsMenu/UploadWhatsMenu';
import UploadYooga from '../UploadYooga/UploadYooga';
import "./ProdutosCatalogo.css";
import imgDefaultImage from './imgs/defaultImage.svg';

const ProdutosCatalogo: React.FC = () => {

  const history = useHistory<any>();
  const location = useLocation<any>();

  const [showLoading, setShowLoading] = useState(false);
  const [catalogoCarregado, setCatalogoCarregado] = useState(false);
  const [listaItemCatalogoProdutos, setListaItemCatalogoProdutos] = useState<any>([]);

  const [showDetalhes, setShowDetalhes] = useState(false);
  const [indice, setIndice] = useState("");
  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");
  const [id, setId] = useState("");
  const [internet, setInternet] = useState(false);
  const [destaque, setDestaque] = useState(false);
  const [disponibilidadeDeliveryDias, setDisponibilidadeDeliveryDias] = useState<number[]>([]);
  const [disponibilidadeDeliveryHorarios, setDisponibilidadeDeliveryHorarios] = useState<{ inicio: string; fim: string }[]>([]);

  const [controlarEstoque, setControlarEstoque] = useState(false);
  const [quantidadeEstoque, setQuantidadeEstoque] = useState("");
  const [quantidadeMinEstoque, setQuantidadeMinEstoque] = useState("");
  const [impressoraSelecionada, setImpressoraSelecionada] = useState("");



  const [grupoComplementos, setGrupoComplementos]: any = useState([{ id: '', name: '', sizeMin: 0, sizeMax: 0, obrigatoriedade: '', itens: [{ id: '', name: '', price: 0, custo: 0, description: '' }] }]);
  const [items, setItems] = useState([{ name: '', price: 0, custo: 0 }]);

  const [codigo, setCodigo] = useState("");
  const [categoria, setCategoria] = useState("");
  const [objetoCategoria, setObjetoCategoria] = useState<any>();
  const [valor, setValor] = useState<any>();
  const [unidadeMedida, setUnidadeMedida] = useState("");
  const [fiscalCategoriaId, setFiscalCategoriaId] = useState("");
  const [listaFiscalCategorias, setListaFiscalCategorias] = useState<any[]>([]);


  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [listaCategoria, setListaCategoria] = useState<any>([]);

  const [isDisabled, setIsDisabled] = useState(true);

  const { loja, setLoja } = useContext(MessageContext);
  const { onboardingData, setOnboardingData } = useContext(OnboardingContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const [fileDataURL, setFileDataURL] = useState<any>(null);
  const [fileArquivos, setFileArquivos] = useState<any>();
  const imageMimeType = /image\/(png|jpg|jpeg|avif|webp)/i;

  const inputRef = useRef<any>(null);

  const inputUploadArquivoRef = useRef<any>(null);

  const [showUploadArquivo, setShowUploadArquivo] = useState(false);
  const [showIfood, setShowIfood] = useState(false);
  const [showAnotaAi, setShowAnotaAi] = useState(false);
  const [showYooga, setShowYooga] = useState(false);
  const [showGoomer, setShowGoomer] = useState(false);
  const [showEcta, setShowEcta] = useState(false);
  const [showInstaDelivery, setShowInstaDelivery] = useState(false);
  const [showWhatsMenu, setShowWhatsMenu] = useState(false);
  const [showIA, setShowIA] = useState(false);
  const [showKivoPedidos, setShowKivoPedidos] = useState(false);
  const [urlIfood, setUrlIfood] = useState<any>();
  const [alertaPreenchimento, setAlertaPreenchimento] = useState(false);

  const [mostartAlerta] = useIonAlert();

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);



  // Estado para armazenar os valores como um array
  const [valores, setValores] = useState<string[]>([]);

  // Estado para custo (produto simples) e custos por tamanho (pizzas)
  const [custo, setCusto] = useState("");
  const [custos, setCustos] = useState<string[]>([]);

  const [showPopover, setShowPopover] = useState(false);
  const [popoverEvent, setPopoverEvent] = useState(null);


  const [showPopoverGrid, setShowPopoverGrid] = useState(false);
  const [popoverEventGrid, setPopoverEventGrid] = useState(null);
  const [itemSelecionado, setItemSelecionado] = useState<any>(null); // Variável para armazenar o item clicado


  const contentRef = useRef<HTMLIonContentElement | null>(null);
  const [etapa, setEtapa] = useState<any>("1");

  const [isItemValid, setIsItemValid] = useState(false);

  const contentNomeGrupoComplementoRef = useRef<any>(null);
  const selectComplementoRefs = useRef<(HTMLIonSelectElement | null)[]>([]);


  const [showModalQrCode, setShowModalQrCode] = useState(false);
  const [qrCodeData, setQRCodeData] = useState<string | null>(null);
  const [qrCode, setQRCode] = useState<any>();

  const [catalogoDelivery, setCatalogoDelivery] = useState<any>();
  const [showModalCatalogoDelivery, setShowModalCatalogoDelivery] = useState(false);
  const [showModalCorCatalogoDelivery, setShowModalCorCatalogoDelivery] = useState(false);

  // Controle do Action Sheet de Importação
  const [showImportMenu, setShowImportMenu] = useState(false);

  const normalize = (s: any) =>
    String(s || '').trim().toLowerCase();

  type PizzaValor = {
    name?: string;
    valor?: string;
    custo?: string;
  };

  type CategoriaPizza = {
    tamanhos?: PizzaValor[];
  };

  const mapPizzaValoresToCategoriaOrder = (
    categoriaAtual: CategoriaPizza | null | undefined,
    produtoValores: PizzaValor[] = []
  ) => {
    const tamanhosRaw = categoriaAtual?.tamanhos;

    const tamanhos = Array.isArray(tamanhosRaw)
      ? tamanhosRaw
      : [];

    const map = new Map(
      produtoValores.map((pizzaValor: PizzaValor) => [
        normalize(pizzaValor?.name),
        pizzaValor
      ])
    );

    const mapField = (field: 'valor' | 'custo') =>
      tamanhos.map((tamanho: PizzaValor) => {
        const key = normalize(tamanho?.name);
        return map.get(key)?.[field] ?? '';
      });

    return {
      valoresOrdenados: mapField('valor'),
      custosOrdenados: mapField('custo'),
    };
  };

  const setPizzaFormState = (
    categoriaAtual: CategoriaPizza | null | undefined,
    produtoValores: PizzaValor[] = []
  ) => {
    const tamanhos = categoriaAtual?.tamanhos;

    if (!Array.isArray(tamanhos) || tamanhos.length === 0) {
      setValores([]);
      setCustos([]);
      return;
    }

    const quantidadeTamanhos = tamanhos.length;

    if (!produtoValores.length) {
      setValores(Array(quantidadeTamanhos).fill(''));
      setCustos(Array(quantidadeTamanhos).fill(''));
      return;
    }

    const { valoresOrdenados, custosOrdenados } =
      mapPizzaValoresToCategoriaOrder(
        categoriaAtual,
        produtoValores
      );

    setValores(valoresOrdenados);
    setCustos(custosOrdenados);
  };

  const buildPizzaValoresPayload = (
    categoriaAtual: CategoriaPizza | null | undefined,
    valoresAtuais: string[],
    custosAtuais: string[]
  ) => {
    const tamanhos = categoriaAtual?.tamanhos;

    if (!Array.isArray(tamanhos)) {
      return [];
    }

    return tamanhos.map((tamanho: PizzaValor, index: number) => {
      const valor = valoresAtuais[index] || '';
      const custo = custosAtuais[index];

      const pizzaValor: PizzaValor = {
        ...tamanho,
        valor,
        ...(custo?.trim() ? { custo } : {})
      };

      return pizzaValor;
    });
  };

  const getPizzaValoresDisplay = (item: any) => {
    if (!item?.valores?.length) return '';

    const categoria = listaCategoria.find(
      (c: any) => normalize(c?.nome) === normalize(item?.categoria)
    );

    // 🔁 fallback simples se não achar categoria
    if (!categoria?.tamanhos) {
      return item.valores
        .map((v: any) => v?.valor)
        .filter(Boolean)
        .join(' | ');
    }

    // 🔥 ordena baseado nos tamanhos
    const { valoresOrdenados } = mapPizzaValoresToCategoriaOrder(
      categoria,
      item.valores
    );

    return valoresOrdenados
      .filter(Boolean)
      .join(' | ');
  };

  // Cor selecionada para o catálogo digital
  const [catalogColor, setCatalogColor] = useState<string>('');
  const paletteColors = [
    // 🔹 Neutras
    '#000000', // black
    '#1C1C1C', // very dark gray
    '#2F4F4F', // dark slate gray
    '#36454F', // charcoal
    '#4B4B4B', // dark gray
    '#555555', // dim gray
    '#708090', // slate gray
    '#2E2E2E', // jet

    // 🔴 Vermelhos
    '#FF0000', // red
    '#8B0000', // dark red
    '#800000', // maroon
    '#B22222', // firebrick
    '#A52A2A', // brown
    '#DC143C', // crimson
    '#7B3F00', // russet

    // 🟠 Laranjas
    '#FF4500', // orange red
    '#FF8C00', // dark orange
    '#E65100', // deep orange 900
    '#FF6347', // tomato

    // 🟡 Amarelos escuros (quase mostarda)
    '#B8860B', // dark goldenrod
    '#DAA520', // goldenrod
    '#FFB300', // amber 800

    // 🟢 Verdes
    '#006400', // dark green
    '#008000', // green
    '#228B22', // forest green
    '#2E8B57', // sea green
    '#556B2F', // dark olive green
    '#013220', // dark hunter green
    '#3E8E41', // classic dark green

    // 🟢 Verde água / teal
    '#008080', // teal
    '#006666', // teal dark
    '#004C4C', // deep teal
    '#20B2AA', // light sea green (ainda escuro)

    // 🔵 Azuis
    '#000080', // navy
    '#00008B', // dark blue
    '#0000CD', // medium blue
    '#191970', // midnight blue
    '#1E3A8A', // indigo 900
    '#4169E1', // royal blue
    '#4682B4', // steel blue
    '#5F9EA0', // cadet blue
    '#27408B', // dark slate blue
    '#483D8B', // dark slate blue

    // 🟣 Roxos
    '#800080', // purple
    '#4B0082', // indigo
    '#6A0DAD', // amethyst dark
    '#7B1FA2', // deep purple
    '#9932CC', // dark orchid
    '#8A2BE2', // blue violet

    // 🟤 Marrons
    '#654321', // dark brown
    '#5D4037', // brown 800
    '#3E2723', // espresso
  ];



  const [categoriaSelecionada, setCategoriaSelecionada] = useState(''); // Estado para armazenar a categoria

  const [busca, setBusca] = useState(''); // Estado para armazenar a categoria

  const [itemCatalogoParaComplementos, setItemCatalogoParaComplementos] = useState(''); // Estado para armazenar a categoria

  const isWeb = isPlatform('desktop');

  const openPopover = (e: any) => {
    e.persist();
    setPopoverEvent(e);
    setShowPopover(true);
  };

  const closePopover = () => {
    setShowPopover(false);
    setPopoverEvent(null);
  };


  const openPopoverGrid = (e: any, item: any) => {
    e.persist();
    setPopoverEventGrid(e); // Seta o evento para abrir o popover
    setItemSelecionado(item); // Seta o item clicado
    setShowPopoverGrid(true); // Abre o popover
  };

  const closePopoverGrid = () => {
    setShowPopoverGrid(false); // Fecha o popover
    setPopoverEventGrid(null); // Reseta o evento
    setItemSelecionado(null); // Reseta o item selecionado
  };

  // Carrega a cor atual ao montar ou quando dadosEmpresa mudar
  useEffect(() => {
    if (dadosEmpresa && dadosEmpresa.color) {
      setCatalogColor(dadosEmpresa.color);
    }
  }, [dadosEmpresa]);

  const salvarCorCatalogo = (catalogColor: string) => {
    if (!catalogColor) {
      setTextToast('Selecione uma cor antes de salvar.');
      setShowToast(true);
      return;
    }

    const url = alterarCorCatalogoDigital.url.replace('{id}', loja.replaceAll(/#/g, '%23'));
    const body = JSON.stringify({ color: catalogColor });
    setShowLoading(true);
    requestService(url, {
      method: alterarCorCatalogoDigital.method,
      headers: [
        ["token", localStorage.getItem("token") || ""]
      ],
      body,
      credentials: 'include'
    }, history, (resp: any) => {
      // Atualiza dadosEmpresa local se retornar a cor
      if (resp && resp.Item && resp.Item.Attributes && resp.Item.Attributes.color) {
        const novo = { ...dadosEmpresa, color: resp.Item.Attributes.color };
        setDadosEmpresa(novo);
        setShowLoading(false);
      } else {
        setTextToast('Não foi possível atualizar a cor.');
        setShowToast(true);
        setShowLoading(false);
      }

    }, (err: any) => {
      console.error(err);
      setTextToast('Não foi possível atualizar a cor.');
      setShowToast(true);
      setShowLoading(false);
    });
  };

  useEffect(() => {

    // console.log("*****************", fileArquivos);
    let fileReader: FileReader, isCancel = false;
    if (fileArquivos) {
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const result = e.target;
        if (result && !isCancel) {
          setFileDataURL(result.result);
          // atualizarTamanhoImagem();
        }
      }
      fileReader.readAsDataURL(fileArquivos);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    }
  }, [fileArquivos]);


  // useEffect(() => {

  //   console.log("*****************carregarEmpresa");
  //   carregarEmpresa();
  // }, []);

  function carregarEmpresa() {
    setCatalogoCarregado(false);
    setShowLoading(true);

    const consultar = async () => {

      requestService(empresaCarregar.url.replace("{id}", loja.replaceAll(/#/g, '%23')).concat("?filtro=", Buffer.from(loja).toString("base64")), {
        method: empresaCarregar.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          setDadosEmpresa(response.Item);

          setListaItemCatalogoProdutos(response.Item.catalogoProdutos || []);
          setListaCategoria(response.Item.categoriaProdutos || []);

          setCatalogoCarregado(true);
          setShowLoading(false);
        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");

    // Recarrega os dados da empresa sempre que a tela voltar ao foco
    carregarEmpresa();
    carregarCategoriasFiscais();
  });

  function carregarCategoriasFiscais() {
    if (!loja) return;
    const url = fiscalListarCategorias.url.replace('{empresaId}', encodeURIComponent(loja));
    requestService(url, { method: fiscalListarCategorias.method }, history,
      (response: any) => {
        if (response.dados && Array.isArray(response.dados)) {
          setListaFiscalCategorias(response.dados);
        }
      },
      (error: any) => {
        console.log("Erro ao carregar categorias fiscais:", error);
      });
  }


  // function carregarConta() {

  //   const consultar = async () => {

  //     //console.log("aasasasasa", loja);
  //     let id = loja;

  //     requestService(empresaAssinadoCarregar.url.replace("{id}", id.replaceAll(/#/g, '%23')).concat("?filtro=", Buffer.from(loja).toString("base64")), {
  //       method: empresaAssinadoCarregar.method,
  //       headers: [
  //         ["token", window.localStorage.getItem("token")]
  //       ],
  //       credentials: 'include'
  //     },
  //       history,
  //       (response: any) => {
  //         // console.log(response);
  //         setListaItemCatalogoProdutos(response.Item.catalogoProdutos || []);
  //         setListaCategoria(response.Item.categoriaProdutos || []);
  //         setShowLoading(false);
  //       },
  //       (error: any) => {
  //         console.log(error);
  //         history.replace("/login/");
  //       });

  //   }

  //   consultar();
  // }


  const itensFiltrados = listaItemCatalogoProdutos
    .map((value: any, index: any) => ({ ...value, index })) // Preservar o índice original
    .filter((value: any) => {
      const categoriaFiltrada = categoriaSelecionada === '' || value.categoria === categoriaSelecionada;
      const buscaFiltrada = busca === '' || value.nome.toLowerCase().includes(busca.toLowerCase());

      return categoriaFiltrada && buscaFiltrada;
    });



  function deletarItemCatalogoProdutos(indice: any) {

    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const delItemCatalogoProdutos = async () => {
      setShowLoading(true);
      const resp = await fetch(removerItemCatalogoProdutosEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
        {
          method: removerItemCatalogoProdutosEmpresa.method,
          headers: [
            ["token", token]
          ],
          body: JSON.stringify({ 'indice': indice }),
          credentials: 'include'
        });
      const retorno = await resp.json();
      // console.log("retorno", retorno);

      if (retorno && retorno.Item?.Attributes) {
        setTextToast("Item do catálogo removido com sucesso.");
        setShowToast(true);
        setListaItemCatalogoProdutos(retorno.Item?.Attributes?.catalogoProdutos || []);
        dadosEmpresa.catalogoProdutos = retorno.Item?.Attributes?.catalogoProdutos;
        setDadosEmpresa(dadosEmpresa);

      }
      else {
        setTextToast("Ocorreu um erro ao efetuar a exclusão.");
        setShowToast(true);
      }
    }

    delItemCatalogoProdutos().finally(() => {
      setShowLoading(false);
    });

  }

  const agruparPorCategoria = (itens: any[], listaCategoria: any[]) => {
    // Agrupa os itens por categoria
    const agrupados = itens.reduce((acc: any, item: any) => {
      const categoria = item.categoria || 'Sem Categoria'; // Adiciona a categoria "Sem Categoria" se não houver uma definida
      if (!acc[categoria]) {
        acc[categoria] = [];
      }
      acc[categoria].push(item);
      return acc;
    }, {});

    // Cria um objeto com categorias na ordem da listaCategoria
    // Inclui somente categorias que têm itens
    const resultadoOrdenado = listaCategoria.reduce((acc: any, categoria: any) => {
      const nomeCategoria = categoria.nome || categoria; // Acessa o nome da categoria
      if (agrupados[nomeCategoria] && agrupados[nomeCategoria].length > 0) {
        acc[nomeCategoria] = agrupados[nomeCategoria];
      }
      return acc;
    }, {});

    // Adiciona "Sem Categoria" se houver itens sem uma categoria definida
    if (agrupados['Sem Categoria'] && agrupados['Sem Categoria'].length > 0) {
      resultadoOrdenado['Sem Categoria'] = agrupados['Sem Categoria'];
    }

    return resultadoOrdenado;
  };


  // const agruparPorCategoria = (itens: any[], listaCategoria: any[]) => {
  //   // Agrupa os itens por categoria
  //   const agrupados = itens.reduce((acc: any, item: any) => {
  //     const categoria = item.categoria || 'Sem Categoria';
  //     if (!acc[categoria]) {
  //       acc[categoria] = [];
  //     }
  //     acc[categoria].push(item);
  //     return acc;
  //   }, {});

  //   // Cria um objeto com categorias na ordem da listaCategoria, incluindo "Sem Categoria" se necessário
  //   const resultadoOrdenado = listaCategoria.reduce((acc: any, categoria: any) => {
  //     const nomeCategoria = categoria.nome || categoria; // Acessa o nome da categoria
  //     if (agrupados[nomeCategoria]) {
  //       acc[nomeCategoria] = agrupados[nomeCategoria];
  //     } else {
  //       acc[nomeCategoria] = [];
  //     }
  //     return acc;
  //   }, {});

  //   // Adiciona "Sem Categoria" se necessário
  //   if (agrupados['Sem Categoria']) {
  //     resultadoOrdenado['Sem Categoria'] = agrupados['Sem Categoria'];
  //   } else if (!resultadoOrdenado['Sem Categoria']) {
  //     resultadoOrdenado['Sem Categoria'] = [];
  //   }

  //   return resultadoOrdenado;
  // };



  function getButtonsGrid(value: any) {

    let resultado: any = [];

    if (acessos?.configuracoes == 'edicao') {


      resultado.push(
        {
          text: 'Editar',
          disabled: false,
          icon: pencilOutline,
          handler: () => {

            setIndice(value.indice);
            setNome(value.nome);
            setId(value.id);
            setDescricao(value.descricao);
            setFileArquivos(null);
            setFileDataURL(value.urlImagem || null);
            setInternet(value.internet);
            setDestaque(value.destaque || false);
            setDisponibilidadeDeliveryDias(value.disponibilidadeDelivery?.dias || []);
            setDisponibilidadeDeliveryHorarios(value.disponibilidadeDelivery?.horarios || []);
            setControlarEstoque(value.controlarEstoque);
            setQuantidadeEstoque(value.quantidadeEstoque);
            setQuantidadeMinEstoque(value.quantidadeMinEstoque);
            setImpressoraSelecionada(value.impressoraSelecionada || "");
            setGrupoComplementos(value.grupoComplementos);
            setCodigo(value.codigo);
            setCategoria(value.categoria);

            // Carregar custo do produto
            setCusto(value.custo || "");


            let found;
            found = listaCategoria.find((obj: any) => {
              return obj.nome === value.categoria;
            });
            console.log("found", found);
            setObjetoCategoria(found);

            // Limpa grupoComplementos se o item é do tipo complementos
            if (found?.tipo === "complementos") {
              setGrupoComplementos([]);
            }

            if (found?.tipo == "pizzas") {

              console.log("value.valores", value.valores);
              setPizzaFormState(found, value.valores || []);
              setValor("");
            }
            else {
              setValor(value.valor);
              setValores([]);
              setCustos([]);
            }

            setEtapa("1");
            setIsItemValid(false);
            setUnidadeMedida(value.unidadeMedida);
            setFiscalCategoriaId(value.fiscalCategoriaId || "");
            setShowDetalhes(true);

          }
        });


      resultado.push(
        {
          text: 'Duplicar',
          disabled: false,
          icon: copyOutline,
          handler: () => {

            setIndice("");
            setNome(value.nome);
            setId(value.id);
            setDescricao(value.descricao);
            setFileArquivos(null);
            setFileDataURL(null);
            setInternet(value.internet);
            setDestaque(value.destaque || false);
            setDisponibilidadeDeliveryDias(value.disponibilidadeDelivery?.dias || []);
            setDisponibilidadeDeliveryHorarios(value.disponibilidadeDelivery?.horarios || []);
            setControlarEstoque(value.controlarEstoque);
            setQuantidadeEstoque(value.quantidadeEstoque);
            setQuantidadeMinEstoque(value.quantidadeMinEstoque);
            setImpressoraSelecionada(value.impressoraSelecionada || "");
            setGrupoComplementos(value.grupoComplementos);
            setCodigo(value.codigo);
            setCategoria(value.categoria);

            let found;
            found = listaCategoria.find((obj: any) => {
              return obj.nome === value.categoria;
            });
            console.log("found", found);
            setObjetoCategoria(found);

            // Limpa grupoComplementos se o item é do tipo complementos
            if (found?.tipo === "complementos") {
              setGrupoComplementos([]);
            }

            if (found?.tipo == "pizzas") {

              console.log("value.valores", value.valores);
              setPizzaFormState(found, value.valores || []);
              setValor("");
            }
            else {
              setValor(value.valor);
              setValores([]);
              setCustos([]);
            }

            // Carregar custo do produto no Duplicar
            setCusto(value.custo || "");

            setEtapa("1");
            setIsItemValid(false);
            setUnidadeMedida(value.unidadeMedida);
            setFiscalCategoriaId(value.fiscalCategoriaId || "");
            setShowDetalhes(true);

          }
        });



      resultado.push(
        {
          text: 'Excluir',
          disabled: false,
          icon: trashOutline,
          handler: () => {
            mostartAlerta({
              backdropDismiss: false,
              header: "Remover item",
              message: "Deseja <strong>remover</strong>?",
              buttons: [
                { text: "Cancelar", role: "cancel" },
                {
                  text: "Confirmar",
                  cssClass: "primary",
                  handler: () => deletarItemCatalogoProdutos(value.indice),
                },
              ],
            });
          }
        }
      );
    }


    resultado.push(
      {
        text: 'Cancelar',
        disabled: false,
        icon: closeOutline,
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      });


    return resultado;
  }

  const loadItemCatalogoProdutos = () => {
    if (!listaItemCatalogoProdutos || !catalogoCarregado) return;

    // Agrupar itens por categoria
    const itensAgrupados = agruparPorCategoria(itensFiltrados, listaCategoria);

    if (listaItemCatalogoProdutos.length === 0) {
      return (
        <div className="catalogo-empty-state">
          <h2 className="catalogo-empty-title">Catálogo de produtos</h2>
          <p className="catalogo-empty-subtitle">Configure seu cardápio para começar a vender pelo Xeguei.</p>

          {/* Criar categorias */}
          <div className="catalogo-empty-card">
            <div className="catalogo-empty-card-icon">
              <IonIcon icon={listOutline} />
            </div>
            <div className="catalogo-empty-card-info">
              <strong>Criar categorias</strong>
              <span>Organize seus produtos</span>
            </div>
            <IonButton fill="outline" style={{ width: '120px' }} size="small" onClick={() => history.push('./produtoscategoriasnovo')}>
              Criar
            </IonButton>
          </div>

          {/* Adicionar produtos */}
          <div className="catalogo-empty-card">
            <div className="catalogo-empty-card-icon">
              <IonIcon icon={fastFoodOutline} />
            </div>
            <div className="catalogo-empty-card-info">
              <strong>Adicionar produtos</strong>
              <span>Cadastre itens para vender</span>
            </div>
            <IonButton fill="outline" style={{ width: '120px' }} size="small" onClick={() => {
              abrirNovoProduto();
            }}>
              Adicionar
            </IonButton>
          </div>

          {/* Importar iFood */}
          <div className="catalogo-empty-card">
            <div className="catalogo-empty-card-icon">
              <IonIcon icon={downloadOutline} />
            </div>
            <div className="catalogo-empty-card-info">
              <strong>Importar iFood</strong>
              <span>Importe seu catálogo automaticamente.</span>
            </div>
            <IonButton fill="outline" style={{ width: '120px' }} size="small" onClick={() => setShowImportMenu(true)}>
              Importar
            </IonButton>
          </div>

          {/* Cor do catálogo */}
          <div className="catalogo-empty-card">
            <div className="catalogo-empty-card-icon">
              <IonIcon icon={colorPaletteOutline} />
            </div>
            <div className="catalogo-empty-card-info">
              <strong>Cor do catálogo</strong>
              <span>Personalize a aparência do cardápio</span>
            </div>
            <IonButton fill="outline" style={{ width: '120px' }} size="small" onClick={() => setShowModalCorCatalogoDelivery(true)}>
              Alterar
            </IonButton>
          </div>
        </div>
      );
    }

    return (
      <>


        <IonPopover
          isOpen={showPopoverGrid}
          event={popoverEventGrid}
          onDidDismiss={closePopoverGrid}
        >
          <IonList>
            {getButtonsGrid(itemSelecionado).map((button: any, btnIndex: number) => (
              <IonItem key={btnIndex} lines="none" disabled={button.disabled} button onClick={() => {
                if (button.handler) button.handler();
                closePopoverGrid(); // Fecha o popover após a ação
              }}>
                <IonIcon icon={button.icon} slot="start" />
                <IonLabel>{button.text}</IonLabel>
              </IonItem>
            ))}
          </IonList>
        </IonPopover>


        {Object.keys(itensAgrupados).map((categoria, catIndex) => (
          <div key={"categoria-" + catIndex}>

            <IonItem lines="none">
              <IonLabel>
                <h2><b>{categoria}</b></h2>
              </IonLabel>
            </IonItem>



            {/* <div key={"categoria2-" + catIndex} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <IonItem lines="none" style={{ flex: 1 }}>
                <IonLabel>
                  <h2><b>{categoria}</b></h2>
                </IonLabel>
              </IonItem>
              <IonButton fill="outline" color="danger">
                <IonIcon slot="start" icon={add} />
                Adicionar item
              </IonButton>
            </div> */}
            <IonItem lines="none" style={{ fontWeight: 'bold', borderBottom: '1px solid #dddddd' }}>
              <IonLabel style={{ fontSize: "12px", maxWidth: "60px" }}></IonLabel>
              <IonLabel style={{ fontSize: "12px" }}>Nome</IonLabel>
              <IonLabel hidden={(!isPlatform('mobileweb') && isPlatform('mobile'))} style={{ fontSize: "12px" }}>Código</IonLabel>
              <IonLabel hidden={(!isPlatform('mobileweb') && isPlatform('mobile'))} style={{ fontSize: "12px" }}>Estoque</IonLabel>
              <IonLabel style={{ textAlign: "center", fontSize: "12px" }}>Valor</IonLabel>
              <IonLabel style={{ textAlign: "right", maxWidth: "60px" }}>
                <IonBadge hidden={acessos?.configuracoes != 'edicao'}
                  onClick={() => setIsDisabled((current) => !current)}>
                  <IonIcon color="medium" icon={reorderTwo}></IonIcon>
                </IonBadge>
              </IonLabel>
            </IonItem>
            <IonReorderGroup disabled={isDisabled} onIonItemReorder={(event) => handleReorder(event, categoria)}>
              {itensAgrupados[categoria].map((value: any, index: any) => (
                <IonItem lines="none" key={"produto-" + index}>
                  <IonLabel style={{ fontSize: "12px", maxWidth: "60px" }}>

                    <div style={{ position: 'relative', display: 'inline-block' }}>
                      {/* Imagem */}
                      <img
                        id="imagem"
                        style={{
                          objectFit: 'cover',
                          width: "50px",
                          height: "50px",
                          borderRadius: '5px'
                        }}
                        src={value.urlImagem || imgDefaultImage}
                      />

                      {/* Ícone da estrela */}
                      <IonIcon
                        color="danger"
                        icon={book}
                        hidden={!value.internet}
                        style={{
                          position: 'absolute',
                          top: '2px',
                          right: '2px',
                          fontSize: '12px', // Ajuste o tamanho da estrela conforme necessário
                          zIndex: 1 // Certifica-se de que o ícone fique acima da imagem
                        }}
                      />

                      {/* Ícone de destaque */}
                      <IonIcon
                        color="warning"
                        icon={star}
                        hidden={!value.destaque}
                        style={{
                          position: 'absolute',
                          top: '2px',
                          left: '2px',
                          fontSize: '12px',
                          zIndex: 1
                        }}
                      />
                    </div>
                  </IonLabel>
                  <IonLabel style={{ fontSize: "12px" }}>{value.nome}</IonLabel>
                  <IonLabel hidden={(!isPlatform('mobileweb') && isPlatform('mobile'))} style={{ fontSize: "12px" }}>{value.codigo}</IonLabel>
                  <IonLabel hidden={(!isPlatform('mobileweb') && isPlatform('mobile'))} style={{ fontSize: "12px" }}>{value.quantidadeEstoque}</IonLabel>

                  <IonLabel style={{ textAlign: "center", fontSize: "12px" }}>
                    {value.valor
                      ? value.valor?.toLocaleString('pt-br', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                      :
                      getPizzaValoresDisplay(value)}
                  </IonLabel>

                  <IonLabel style={{ maxWidth: "60px" }}></IonLabel>



                  <div style={{ position: "absolute", right: "6px", zIndex: 9999999, backgroundColor: "#ffffff", textAlign: "right" }}>

                    <IonButtons slot="end">
                      <IonButton color="primary" onClick={(e) => openPopoverGrid(e, value)}>
                        <IonIcon slot="icon-only" icon={ellipsisVertical} />
                      </IonButton>
                    </IonButtons>

                  </div>

                  <div style={{ position: "absolute", right: "10px", zIndex: 9999999, backgroundColor: "#ffffff", textAlign: "right" }}>
                    <IonReorder slot="end"></IonReorder>
                  </div>

                </IonItem>
              ))}
            </IonReorderGroup>
          </div >
        ))}
      </>
    );

  };

  // Função de reordenação específica para cada categoria
  function handleReorder(event: CustomEvent<ItemReorderEventDetail>, categoria: string) {
    // Clonar a lista de produtos
    const novaLista = [...listaItemCatalogoProdutos];

    // Encontrar os itens da categoria
    const itensDaCategoria = novaLista.filter((item: any) => item.categoria === categoria);

    // Atualizar a posição dos itens dentro da categoria
    const itensReordenados = event.detail.complete(itensDaCategoria);

    // Substituir os itens da categoria pela nova ordem
    const listaAtualizada = novaLista.map((item: any) => {
      if (item.categoria === categoria) {
        return itensReordenados.shift();
      }
      return item;
    });

    // Atualizar o estado com a nova lista ordenada
    setListaItemCatalogoProdutos(listaAtualizada);

    // Realizar a ordenação no servidor
    const ordenarItens = async () => {
      setShowLoading(true);
      const token = localStorage.getItem("token") || "";
      const resp = await fetch(ordernarItemCatalogoProdutosEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")), {
        method: ordernarItemCatalogoProdutosEmpresa.method,
        headers: [["token", token]],
        body: JSON.stringify({ catalogoProdutos: listaAtualizada }),
        credentials: "include",
      });
      const retorno = await resp.json();

      if (retorno?.Item?.Attributes) {
        // setTextToast("Ordenação alterada com sucesso.");
        // setShowToast(true);
        setListaItemCatalogoProdutos(retorno.Item.Attributes.catalogoProdutos);
        dadosEmpresa.catalogoProdutos = retorno.Item.Attributes.catalogoProdutos;
        setDadosEmpresa(dadosEmpresa);
      } else {
        setTextToast("Ocorreu um erro ao ordenar.");
        setShowToast(true);
      }

    };

    ordenarItens().finally(() => {
      setShowLoading(false);
    });
  }


  async function assinaUploadS3ArquivoESalvar(file: any) {
    const atualizar = async () => {

      try {
        // Ativa o loading
        setShowLoading(true);



        let fileParts = file && file.name ? file.name.split('.') : [];
        let fileNameArquivo = fileParts[0] || '';
        let fileTypeArquivo = fileParts[1] || '';

        let params = {
          nome: fileNameArquivo,
          tipo: fileTypeArquivo
        }

        let urlImagem = '', nomeImagem = '', tipoImagem = '';

        // console.log("file", file);
        if (file && file.name) {
          // Assina URL
          const resp = await fetch(assinaUrl.url.concat("?pasta=produtos-catalago&bucket=xeguei-mobile-publico"), {
            method: assinaUrl.method,
            headers: [
              ["token", localStorage.getItem("token") || ""]
            ],
            body: JSON.stringify(params),
            credentials: 'include'
          });

          const response = await resp.json();

          if (response.Item) {




            // const compressedFile = await imageCompression(file, {
            //   maxSizeMB: 0.1,
            //   maxWidthOrHeight: 600,
            //   useWebWorker: true,
            //   initialQuality: 0.5
            // });

            // console.log("Tamanho comprimido:", compressedFile.size);

            // console.log("fileTypeArquivo", fileTypeArquivo);

            const uploadToS3 = await fetch(response.Item.urlAssinado, {
              method: "PUT",
              headers: {
                "Content-Type": "image/" + fileTypeArquivo,
              },
              body: file,
            });

            if (uploadToS3.status === 200) {
              urlImagem = response.Item.urlPublica;
              nomeImagem = response.Item.fileName;
              tipoImagem = fileTypeArquivo;
            } else {
              throw new Error('Erro ao fazer upload do arquivo.');
            }
          } else {
            throw new Error('Erro ao assinar a URL.');
          }
        }

        const pizzaValoresOrdenados = buildPizzaValoresPayload(
          objetoCategoria,
          valores,
          custos
        );

        const objectRequest: any = {
          nome: nome,
          descricao: descricao,
          id: id,
          internet: internet,
          urlImagem: urlImagem,
          nomeImagem: nomeImagem,
          tipoImagem: tipoImagem,
          codigo: codigo,
          categoria: categoria,
          grupoComplementos: objetoCategoria?.tipo === "complementos" ? [] : grupoComplementos,
          valor: valor,
          valores: pizzaValoresOrdenados,
          tipo: objetoCategoria ? objetoCategoria.tipo : "simples",
          unidadeMedida: unidadeMedida,
          fiscalCategoriaId: fiscalCategoriaId || undefined,
          controlarEstoque: controlarEstoque,
          quantidadeEstoque: quantidadeEstoque,
          quantidadeMinEstoque: quantidadeMinEstoque,
          impressoraSelecionada: impressoraSelecionada,
          destaque: destaque,
          indice: indice || null,
          disponibilidadeDelivery: {
            dias: disponibilidadeDeliveryDias,
            ...(disponibilidadeDeliveryHorarios.length > 0 && { horarios: disponibilidadeDeliveryHorarios })
          }
        };

        // Incluir custo (produto simples)
        if (custo && custo.trim() !== '') {
          objectRequest.custo = custo;
        } else {
          objectRequest.custo = '';
        }

        let url = indice ? alterarItemCatalogoProdutosEmpresa.url : inserirItemCatalogoProdutosEmpresa.url;

        await requestService(
          url.replace("{id}", loja.replaceAll("#", "%23")),
          {
            method: indice ? alterarItemCatalogoProdutosEmpresa.method : inserirItemCatalogoProdutosEmpresa.method,
            body: JSON.stringify(objectRequest),
            headers: [
              ["token", window.localStorage.getItem("token")]
            ],
            credentials: 'include'
          },
          history,
          (response: any) => {
            if (response) {
              setTextToast("Novo item cadastrado com sucesso.");
              setShowToast(true);

              setListaItemCatalogoProdutos(response.message.Attributes?.catalogoProdutos || []);
              dadosEmpresa.catalogoProdutos = response.message.Attributes?.catalogoProdutos;
              setDadosEmpresa(dadosEmpresa);

              // Marcar etapa do onboarding como concluída
              if (onboardingData && !onboardingData.onboarding_concluido) {
                const urlOnb = onboardingAtualizarEtapa.url
                  .replace("{empresa_id}", onboardingData.empresa_id.replaceAll("#", "%23"));
                requestService(urlOnb, {
                  method: onboardingAtualizarEtapa.method,
                  body: JSON.stringify({ etapa_id: 'catalogo', status: 'concluido' }),
                  headers: [["token", window.localStorage.getItem("token")]],
                  credentials: 'include'
                }, history, (r: any) => { if (r) setOnboardingData(r); }, () => { });
              }

              setShowDetalhes(false);
            } else if (response.status === 400) {
              setTextToast("Ocorreu um erro ao efetuar a operação.");
              setShowToast(true);
            }
          },
          (error: any) => {
            setTextToast("Ocorreu um erro ao efetuar a operação.");
            setShowToast(true);
          }
        );
      } catch (error) {
        console.log("erro", error);
      }
    }
    await atualizar().finally(() => { setShowLoading(false) });
  }

  function sleep(miliseconds: number) {
    var currentTime = new Date().getTime();

    while (currentTime + miliseconds >= new Date().getTime()) {
    }
  }


  // Função para verificar se todos os campos foram preenchidos
  const todosCamposPreenchidos = (): boolean => {
    if (!objetoCategoria || !objetoCategoria.tamanhos) return false;

    // Verifica se todos os campos no array de tamanhos têm um valor correspondente preenchido
    return objetoCategoria.tamanhos.length === valores.length &&
      valores.every(valor => valor.trim() !== ''); // Todos os valores devem ser não vazios
  };

  const validateOpcoes = () => {
    let isValid = true;
    let errors: Array<{ message: string }> = [];

    // Validação dos grupoComplementos

    if (grupoComplementos && Array.isArray(grupoComplementos)) {
      grupoComplementos.forEach((grupoComplementos: any, groupIndex: any) => {
        if (!grupoComplementos.name) {
          isValid = false;
          errors.push({ message: `Nome do grupo de complementos no item ${groupIndex + 1} não pode estar vazio.` });
        }

        if (!grupoComplementos.obrigatoriedade) {
          isValid = false;
          errors.push({ message: `Obrigatoriedade do grupo de complementos no item ${groupIndex + 1} não pode estar vazio.` });
        }

        // console.log("grupoComplementos.sizeMin", grupoComplementos.sizeMin);

        // if (!grupoComplementos.sizeMin) {
        //   isValid = false;
        //   errors.push({ message: `Quantidade Mínima do grupo de complementos no item ${groupIndex + 1} não pode estar vazio.` });
        // }

        // if (!grupoComplementos.sizeMax) {
        //   isValid = false;
        //   errors.push({ message: `Quantidade Máxima do grupo de complementos no item ${groupIndex + 1} não pode estar vazio.` });
        // }

        // Validação dos itens dentro do grupo
        grupoComplementos.itens.forEach((item: any, itemIndex: any) => {
          if (!item.name) {
            isValid = false;
            errors.push({ message: `Nome do item no grupo de complementos ${groupIndex + 1}, item ${itemIndex + 1} não pode estar vazio.` });
          }

          if (!item.price && !item.id) {
            isValid = false;
            errors.push({ message: `Preço do item no grupo de complementos ${groupIndex + 1}, item ${itemIndex + 1} não pode estar vazio.` });
          }
        });
      });
    }

    return { isValid, errors };
  };


  async function salvar() {

    // console.log("valores", valores);

    if (!validateItemForm()) {
      return; // Impede a mudança para a segunda etapa
    }

    // Validar faixas de horário incompletas
    const horarioIncompleto = disponibilidadeDeliveryHorarios.some(f => !f.inicio || !f.fim);
    if (horarioIncompleto) {
      setTextToast('Preencha todos os campos de início e fim nas faixas de horário.');
      setShowToast(true);
      return;
    }

    // Pula validação de complementos se o item sendo cadastrado é do tipo complemento
    if (objetoCategoria?.tipo !== "complementos") {
      const { isValid, errors } = validateOpcoes();

      if (!isValid && errors.length > 0) {
        console.log('Erros de validação:', errors);

        // Mapeia o array de erros e retorna um array de strings para o IonToast
        const errorMessages: any = errors.map((error) => `${error.message}`);
        setTextToast(errorMessages.join('<br>'));
        setShowToast(true);
        return;
      }
    }

    await assinaUploadS3ArquivoESalvar(fileArquivos);












  }

  function readCategoria() {
    return listaCategoria.map((value: any, index: any, array: any) =>
    (
      <IonSelectOption key={"categoria" + index} value={value.nome || value}>{value.nome || value}</IonSelectOption>
    )
    )
  };

  function readCatalogo() {
    // console.log("listaItemCatalogoProdutos", listaItemCatalogoProdutos);
    return listaItemCatalogoProdutos.filter((value: any) => {
      return value.tipo === "complementos";  // Corrigido: adicionado 'return'
    }).map((value: any, index: any, array: any) =>
    (
      <IonSelectOption key={"categoria" + index} value={value.id}>{value.nome || value}</IonSelectOption>
    )
    )
  };


  function onChangeQuantidadeEstoque(e: any) {

    e.persist();
    e.preventDefault();

    // Remove qualquer caractere que não seja número
    let v = e.target.value.replace(/\D/g, '');

    // Atualiza o valor apenas com números inteiros
    setQuantidadeEstoque(v);
  }


  function onChangeQuantidadeMinEstoque(e: any) {

    e.persist();
    e.preventDefault();

    // Remove qualquer caractere que não seja número
    let v = e.target.value.replace(/\D/g, '');

    // Atualiza o valor apenas com números inteiros
    setQuantidadeMinEstoque(v);
  }


  function onChangeValor(e: any) {

    e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");

    setValor(v);
  }

  function onChangeCusto(e: any) {
    e.persist();
    e.preventDefault();
    let v = e.target.value;
    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");
    setCusto(v);
  }

  const onChangeCustoArray = (e: any, index: number) => {
    e.preventDefault();
    let v = e.target.value;
    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");
    const newCustos = [...custos];
    newCustos[index] = v;
    setCustos(newCustos);
  };

  const onChangeCustoItemArray = (e: any, groupIndex: number, itemIndex: number) => {
    e.preventDefault();
    let v = e.target.value;
    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");
    const updated = [...grupoComplementos];
    if (updated[groupIndex]?.itens?.[itemIndex]) {
      updated[groupIndex].itens[itemIndex] = { ...updated[groupIndex].itens[itemIndex], custo: v };
      setGrupoComplementos(updated);
    }
  };

  function getButtons() {
    let resultado: any = [];
    if (acessos?.configuracoes == 'edicao') {

      // resultado.push({
      //   text: 'Aumento de preço',
      //   disabled: false,
      //   icon: arrowUp,
      //   handler: () => {

      //     const aumento = async () => {

      //       var token: string = "";
      //       var tkn = localStorage.getItem("token");
      //       if (typeof (tkn) === "string") { token = tkn; }


      //       let params = {
      //         valor: -15
      //       }

      //       try {

      //         setShowLoading(true);

      //         const resp = await fetch(aumentoCatalogoProdutosEmpresa.url.replaceAll("{id}", loja.replaceAll(/#/g, "%23")),
      //           {
      //             method: aumentoCatalogoProdutosEmpresa.method,
      //             headers: [
      //               ["token", token]
      //             ],
      //             body: JSON.stringify(params),
      //             credentials: 'include'
      //           });

      //         const response = await resp.json();

      //         console.log("response", response);
      //         if (response.message && response.message.Attributes) {

      //           Toast.show({
      //             text: "Aumento de preço com sucesso.",
      //             position: "center",
      //             duration: "long"
      //           });

      //           // dadosEmpresa.catalogoProdutos = response.message.Attributes?.catalogoProdutos;
      //           // setDadosEmpresa(dadosEmpresa);

      //         }
      //         else {
      //           Toast.show({
      //             text: response.message || "Ocorreu um erro ao realizar a importação.",
      //             position: "center",
      //             duration: "long"
      //           });
      //         }
      //         setShowLoading(false);

      //       } catch (error) {
      //         console.log("erro", error);
      //         Toast.show({
      //           text: "Ocorreu um erro ao realizar a importação.",
      //           position: "center",
      //           duration: "long"
      //         });
      //         setShowLoading(false);
      //       }
      //     }

      //     aumento();



      //   }
      // });


      resultado.push({
        text: 'Categorias',
        disabled: false,
        icon: listOutline,
        handler: () => {
          history.push("./produtoscategoriasnovo");
        }
      });



      // resultado.push({
      //   text: 'Importar',
      //   disabled: false,
      //   icon: downloadOutline,
      //   handler: () => {

      //     mostartAlerta({
      //       backdropDismiss: false,
      //       header: 'Importar novo catalogo',
      //       message: 'Todos os itens do catálogo serão <strong>excluídos</strong>. Deseja realmente continuar a importação?',
      //       buttons: [
      //         {
      //           text: 'Cancelar',
      //           role: 'cancel',
      //         },
      //         {
      //           text: 'Confirmar',
      //           cssClass: 'primary',
      //           handler: () => {
      //             setShowUploadArquivo(true);
      //           }
      //         }
      //       ],
      //       onDidDismiss: (e) => console.log('did dismiss'),
      //     })


      //   }
      // });

      resultado.push({
        text: `${'Catálogo ' + (window.localStorage.getItem("nomeInternoMesasOuComandas") || "Mesas") + ' - QrCode'}`,
        disabled: false,
        icon: qrCodeOutline,
        handler: async () => {
          generateQRCode();
        }
      });

      resultado.push({
        text: 'Catálogo Delivery',
        disabled: false,
        icon: bookOutline,
        handler: async () => {
          gerarCatalogoDelivery();
        }
      });

      resultado.push({
        text: 'Cor do Catálogo',
        disabled: false,
        icon: colorPaletteOutline,
        handler: async () => {
          setShowModalCorCatalogoDelivery(true);
        }
      });
    }

    resultado.push({
      text: 'Importar Catalogo',
      disabled: false,
      icon: downloadOutline,
      handler: () => {
        setShowImportMenu(true);
      }
    });

    resultado.push({
      text: 'Cancelar',
      disabled: false,
      icon: closeOutline,
      role: 'cancel',
      handler: () => {
        console.log('Cancel clicked');
      }
    });

    return resultado;
  }

  // async function closeModalUploadArquivo() {
  //   setShowUploadArquivo(false);
  // }

  // async function closeModalUploadArquivoSucess(file: any, fileNameArquivo: any, fileTypeArquivo: any) {
  //   // console.log("file", file);
  //   // console.log("fileNameArquivo", fileNameArquivo);
  //   // console.log("fileTypeArquivo", fileTypeArquivo);


  //   let base64 = await getBase64(file);
  //   // Toast.show({
  //   //   text: "Aguarde a importação do arquivo.",
  //   //   position: "center",
  //   //   duration: "long"
  //   // });
  //   await UploadCatalogoAPI(base64, fileNameArquivo, fileTypeArquivo);

  //   setShowUploadArquivo(false);
  // }


  async function closeModalIfood() {
    setShowIfood(false);
  }

  async function closeModalIfoodSuccess(dadosEmpresa: any) {

    setListaCategoria(dadosEmpresa.categoriaProdutos || []);
    setListaItemCatalogoProdutos(dadosEmpresa.catalogoProdutos || []);

    dadosEmpresa.categoriaProdutos = dadosEmpresa.categoriaProdutos;
    dadosEmpresa.catalogoProdutos = dadosEmpresa.catalogoProdutos;

    setDadosEmpresa(dadosEmpresa);

    setShowIfood(false);
  }

  async function closeModalYooga() {
    setShowYooga(false);
  }

  async function closeModalYoogaSuccess(dadosEmpresa: any) {

    setListaCategoria(dadosEmpresa.categoriaProdutos || []);
    setListaItemCatalogoProdutos(dadosEmpresa.catalogoProdutos || []);

    dadosEmpresa.categoriaProdutos = dadosEmpresa.categoriaProdutos;
    dadosEmpresa.catalogoProdutos = dadosEmpresa.catalogoProdutos;

    setDadosEmpresa(dadosEmpresa);

    setShowYooga(false);
  }

  async function closeModalAnotaAi() {
    setShowAnotaAi(false);
  }

  async function closeModalAnotaAiSuccess(dadosEmpresa: any) {

    setListaCategoria(dadosEmpresa.categoriaProdutos || []);
    setListaItemCatalogoProdutos(dadosEmpresa.catalogoProdutos || []);

    dadosEmpresa.categoriaProdutos = dadosEmpresa.categoriaProdutos;
    dadosEmpresa.catalogoProdutos = dadosEmpresa.catalogoProdutos;

    setDadosEmpresa(dadosEmpresa);

    setShowAnotaAi(false);
  }


  async function closeModalGoomer() {
    setShowGoomer(false);
  }

  async function closeModalGoomerSuccess(dadosEmpresa: any) {

    setListaCategoria(dadosEmpresa.categoriaProdutos || []);
    setListaItemCatalogoProdutos(dadosEmpresa.catalogoProdutos || []);

    dadosEmpresa.categoriaProdutos = dadosEmpresa.categoriaProdutos;
    dadosEmpresa.catalogoProdutos = dadosEmpresa.catalogoProdutos;

    setDadosEmpresa(dadosEmpresa);

    setShowGoomer(false);
  }

  async function closeModalEcta() {
    setShowEcta(false);
  }

  async function closeModalEctaSuccess(dadosEmpresa: any) {

    setListaCategoria(dadosEmpresa.categoriaProdutos || []);
    setListaItemCatalogoProdutos(dadosEmpresa.catalogoProdutos || []);

    dadosEmpresa.categoriaProdutos = dadosEmpresa.categoriaProdutos;
    dadosEmpresa.catalogoProdutos = dadosEmpresa.catalogoProdutos;

    setDadosEmpresa(dadosEmpresa);

    setShowEcta(false);
  }

  async function closeModalInstaDelivery() {
    setShowInstaDelivery(false);
  }

  async function closeModalInstaDeliverySuccess(dadosEmpresa: any) {

    setListaCategoria(dadosEmpresa.categoriaProdutos || []);
    setListaItemCatalogoProdutos(dadosEmpresa.catalogoProdutos || []);

    dadosEmpresa.categoriaProdutos = dadosEmpresa.categoriaProdutos;
    dadosEmpresa.catalogoProdutos = dadosEmpresa.catalogoProdutos;

    setDadosEmpresa(dadosEmpresa);

    setShowInstaDelivery(false);
  }

  async function closeModalWhatsMenu() {
    setShowWhatsMenu(false);
  }

  async function closeModalWhatsMenuSuccess(dadosEmpresa: any) {

    setListaCategoria(dadosEmpresa.categoriaProdutos || []);
    setListaItemCatalogoProdutos(dadosEmpresa.catalogoProdutos || []);

    dadosEmpresa.categoriaProdutos = dadosEmpresa.categoriaProdutos;
    dadosEmpresa.catalogoProdutos = dadosEmpresa.catalogoProdutos;

    setDadosEmpresa(dadosEmpresa);

    setShowWhatsMenu(false);
  }

  async function closeModalIA() {
    setShowIA(false);
  }

  async function closeModalIASuccess(dadosEmpresa: any) {
    setListaCategoria(dadosEmpresa.categoriaProdutos || []);
    setListaItemCatalogoProdutos(dadosEmpresa.catalogoProdutos || []);
    setDadosEmpresa(dadosEmpresa);
    setShowIA(false);
  }

  // async function closeModalKivoPedidos() {
  //   setShowKivoPedidos(false);
  // }

  // async function closeModalKivoPedidosSuccess(dadosEmpresa: any) {

  //   setListaCategoria(dadosEmpresa.categoriaProdutos || []);
  //   setListaItemCatalogoProdutos(dadosEmpresa.catalogoProdutos || []);

  //   dadosEmpresa.categoriaProdutos = dadosEmpresa.categoriaProdutos;
  //   dadosEmpresa.catalogoProdutos = dadosEmpresa.catalogoProdutos;

  //   setDadosEmpresa(dadosEmpresa);

  //   setShowKivoPedidos(false);
  // }


  async function getBase64(file: any) {


    return new Promise((resolve) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.readAsDataURL(file)
    })
  }



  // async function UploadCatalogoAPI(file: any, fileNameArquivo: any, fileTypeArquivo: any) {


  //   const upload = async () => {

  //     var token: string = "";
  //     var tkn = localStorage.getItem("token");
  //     if (typeof (tkn) === "string") { token = tkn; }


  //     let params = {
  //       base64: file,
  //       nome: fileNameArquivo,
  //       tipo: fileTypeArquivo,
  //     }

  //     try {

  //       setShowLoading(true);

  //       const resp = await fetch(uploadCatalogoProdutosEmpresa.url.replaceAll("{id}", loja.replaceAll(/#/g, "%23")),
  //         {
  //           method: uploadCatalogoProdutosEmpresa.method,
  //           headers: [
  //             ["token", token]
  //           ],
  //           body: JSON.stringify(params),
  //           credentials: 'include'
  //         });

  //       const response = await resp.json();

  //       // console.log("response", response);
  //       if (response.message.Attributes) {

  //         Toast.show({
  //           text: "Arquivo foi importado com sucesso.",
  //           position: "center",
  //           duration: "long"
  //         });

  //         setListaItemCatalogoProdutos(response.message.Attributes?.catalogoProdutos || []);
  //         dadosEmpresa.catalogoProdutos = response.message.Attributes?.catalogoProdutos;
  //         setDadosEmpresa(dadosEmpresa);
  //       }
  //       else {
  //         Toast.show({
  //           text: response.message || "Ocorreu um erro ao realizar a importação. Verifique o formato e tente novamente.",
  //           position: "center",
  //           duration: "long"
  //         });
  //       }
  //       setShowLoading(false);

  //     } catch (error) {
  //       console.log("erro", error);
  //       Toast.show({
  //         text: "Ocorreu um erro ao realizar a importação. Verifique o formato e tente novamente.",
  //         position: "center",
  //         duration: "long"
  //       });
  //       setShowLoading(false);
  //     }
  //   }

  //   upload();

  // };

  // Função para atualizar o valor do input no índice específico
  const onChangeValorArray = (e: any, index: number) => {
    // e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");

    const newValues = [...valores];
    newValues[index] = v;
    setValores(newValues);
  };

  // Metodo chamado quando é selecionado um arquivo para subida
  async function ChangeHandlerInputFile(e: any) {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.match(imageMimeType)) {
        alert("Tipo da imagem inválido");
        return;
      }


      // if (fileArquivos && fileArquivos.size > 100000) {
      const fotoReduzida = await ReduzirFoto(file);
      console.log("Tamanho comprimido:", fotoReduzida.size);
      setFileArquivos(fotoReduzida);
      // }
      // else {
      //   setFileArquivos(file);
      // }




    }
    else {
      alert("Arquivo não selecionado");
      return;
    }
  }

  async function ReduzirFoto(file: File) {
    const options = {
      maxSizeMB: 0.05, // Reduzindo o tamanho máximo para 0.05 MB (50 KB)
      maxWidthOrHeight: 400, // Reduzindo a dimensão máxima para 400px
      useWebWorker: true,
      initialQuality: 0.5 // Reduzindo a qualidade inicial para 30%
    }

    return await imageCompression(file, options);
  }

  function atualizarTamanhoImagem() {
    var imagemLogo: any;
    imagemLogo = document.getElementById('imagem');
    var img = new Image();
    img.onload = function () {
      var proporcao = img.width / img.height;
      var novaLargura = 250 * proporcao;
      imagemLogo.style.width = novaLargura + 'px';
    };
    img.src = imagemLogo.src;

  }


  // Função para atualizar o valor do input no índice específico
  const onChangeSizeMinGrupoComplementosArray = (e: any, index: number) => {
    e.preventDefault();

    let v = e.target.value;

    // Remove qualquer coisa que não seja um dígito
    v = v.replace(/\D/g, '');


    const newValues = [...grupoComplementos];
    newValues[index] = { ...newValues[index], sizeMin: v }; // Mantém os outros valores do objeto
    setGrupoComplementos(newValues);
  };
  // Função para atualizar o valor do input no índice específico
  const onChangeSizeMaxGrupoComplementosArray = (e: any, index: number) => {
    e.preventDefault();

    let v = e.target.value;

    // Remove qualquer coisa que não seja um dígito
    v = v.replace(/\D/g, '');


    const newValues = [...grupoComplementos];
    newValues[index] = { ...newValues[index], sizeMax: v }; // Mantém os outros valores do objeto
    setGrupoComplementos(newValues);
  };



  const addGrupoComplementos = () => {

    setGrupoComplementos((prevGrupos: any) => {
      // Verifica se prevGrupos é um array; se não for, inicializa como um array vazio
      const gruposAtuais = Array.isArray(prevGrupos) ? prevGrupos : [];

      // Adiciona o novo grupo ao array
      return [
        ...gruposAtuais,
        {
          name: '',
          // id: uuidv4().replace(/-/g, ""),
          sizeMin: 0,
          sizeMax: 1,
          obrigatoriedade: 'opcional',
          itens: [{ name: '', price: 0, custo: 0 }]
        }
      ];
    });

    setTimeout(() => {
      if (contentNomeGrupoComplementoRef.current) {
        contentNomeGrupoComplementoRef.current.setFocus();
      }
    }, 200);
  };

  const updateGrupoComplementos = (index: number, field: string, value: any) => {
    const newGrupoComplementos: any = [...grupoComplementos];
    newGrupoComplementos[index][field] = value;
    setGrupoComplementos(newGrupoComplementos);
  };

  const removeGrupoComplementos = (index: number) => {
    const newGrupoComplementos = grupoComplementos.filter((_: any, i: any) => i !== index);
    setGrupoComplementos(newGrupoComplementos);
  };


  // Função para atualizar o valor do input no índice específico

  const onChangeValorItemArray = (e: any, groupIndex: number, itemIndex: number) => {
    e.preventDefault();

    let v = e.target.value;
    v = v.replace(/\D/g, ''); // Remove tudo que não é número
    v = v.replace(/(\d{1})(\d{1,2})$/, '$1,$2'); // Formata como decimal

    const newGrupoComplementos = [...grupoComplementos];
    newGrupoComplementos[groupIndex].itens[itemIndex] = {
      ...newGrupoComplementos[groupIndex].itens[itemIndex],
      price: v
    };

    setGrupoComplementos(newGrupoComplementos);
  };


  const addItem = (groupIndex: number) => {
    const newGrupoComplementos = [...grupoComplementos];
    newGrupoComplementos[groupIndex].itens.push({ name: '', price: 0, description: '' });
    setGrupoComplementos(newGrupoComplementos);
  };


  const selectedItem = (groupIndex: number, id: any, name: any, imageName: any, imageType: any, imageUrl: any, price: any, custo: any, description: any) => {
    const newGrupoComplementos = [...grupoComplementos];
    newGrupoComplementos[groupIndex].itens.push({ id: id, name: name, price: price ?? "0,00", custo: custo ?? 0, imageName: imageName, imageType: imageType, imageUrl: imageUrl, description: description || '' });
    setGrupoComplementos(newGrupoComplementos);
  };



  // const selectItem = (groupIndex: number) => {
  //   const newGrupoComplementos = [...grupoComplementos];
  //   newGrupoComplementos[groupIndex].itens.push({ name: '', price: 0, id:  });
  //   setGrupoComplementos(newGrupoComplementos);
  // };


  const updateItem = (groupIndex: number, itemIndex: number, field: string, value: any) => {
    const newGrupoComplementos = [...grupoComplementos];
    newGrupoComplementos[groupIndex].itens[itemIndex][field] = value;
    setGrupoComplementos(newGrupoComplementos);
  };

  const removeItem = (groupIndex: number, itemIndex: number) => {
    const newGrupoComplementos = [...grupoComplementos];
    newGrupoComplementos[groupIndex].itens = newGrupoComplementos[groupIndex].itens.filter((_: any, i: any) => i !== itemIndex);
    setGrupoComplementos(newGrupoComplementos);
  };


  const scrollToTop = () => {
    contentRef.current && contentRef.current.scrollToTop();
  };

  const validateItemForm = () => {
    // Faça a validação aqui, por exemplo, verificar se todos os campos obrigatórios foram preenchidos
    let isValid = true;


    if (objetoCategoria && objetoCategoria.tipo == "pizzas") {

      if (!todosCamposPreenchidos()) {
        setTextToast("Todos os campos de Valores são obrigatórios.");
        setShowToast(true);
        isValid = false;
        setIsItemValid(isValid);
        return isValid;
      }
    }
    else {
      if (!valor || valor.trim() == "") {
        setTextToast("Campo Valor é obrigatório.");
        setShowToast(true);
        isValid = false;
        setIsItemValid(isValid);
        return isValid;
      }

    }


    if (controlarEstoque && (!quantidadeEstoque)) {
      setTextToast("Campo Estoque Atual é obrigatório.");
      setShowToast(true);
      isValid = false;
      setIsItemValid(isValid);
      return isValid;
    }

    if (controlarEstoque && (!quantidadeMinEstoque)) {
      setTextToast("Campo Estoque Mínimo é obrigatório.");
      setShowToast(true);
      isValid = false;
      setIsItemValid(isValid);
      return isValid;
    }



    if (!nome || nome.trim() === "") {
      setTextToast("O campo Nome é obrigatório.");
      setShowToast(true);
      isValid = false;
      setIsItemValid(isValid);
      return isValid;
    }

    // if (!codigo || codigo.trim() === "") {
    //     setTextToast("O campo Código é obrigatório.");
    //     setShowToast(true);
    //     return false;
    // }

    if (!categoria || categoria.trim() === "") {
      setTextToast("O campo Categoria é obrigatório.");
      setShowToast(true);
      isValid = false;
      setIsItemValid(isValid);
      return isValid;
    }

    if (!unidadeMedida || unidadeMedida.trim() === "") {
      setTextToast("O campo Unidade de Medida é obrigatório.");
      setShowToast(true);
      isValid = false;
      setIsItemValid(isValid);
      return isValid;
    }



    if (fileArquivos && fileArquivos.size > 5000000) {


      Toast.show({
        text: "Somente arquivos até 5 MB.",
        position: "center",
        duration: "long"
      });
      isValid = false;
    }
    setIsItemValid(isValid);
    return isValid;

  };

  const handleEtapaChange = (value: any) => {
    if (value === '2' && !validateItemForm()) {
      return; // Impede a mudança para a segunda etapa
    }
    if (value === '2') {
      const horarioIncompleto = disponibilidadeDeliveryHorarios.some(f => !f.inicio || !f.fim);
      if (horarioIncompleto) {
        setTextToast('Preencha todos os campos de início e fim nas faixas de horário.');
        setShowToast(true);
        return;
      }
    }
    if (value === '1') {
      setIsItemValid(false);
    }
    setEtapa(value);
    scrollToTop(); // Função para rolar a tela para o topo
  };

  const generateQRCode = async () => {
    try {
      // Gera o QR code como base64
      const qrData = await QRCode.toDataURL(`https://xeguei.com.br/catalogo.html?parceiro=${loja.replaceAll("empresa#", "")}`);
      setQRCodeData(qrData);
      setQRCode(`https://xeguei.com.br/catalogo.html?parceiro=${loja.replaceAll("empresa#", "")}`);
      setShowModalQrCode(true);
    } catch (err) {
      console.error('Erro ao gerar o QR Code', err);
    }
  };

  const gerarCatalogoDelivery = async () => {
    try {
      const empresa = dadosEmpresa || {};
      const dominio = empresa.dominio
        ? `https://${empresa.dominio}`
        : empresa.slug
          ? `https://${empresa.slug}.xeguei.com.br`
          : `https://cliente.xeguei.com.br/?empresaid=${(empresa.pk || loja).replace('empresa#', '')}`;
      setCatalogoDelivery(dominio);
      setShowModalCatalogoDelivery(true);
    } catch (err) {
      console.error('Erro ao gerar o QR Code', err);
    }
  };

  const handlePrint = () => {


    const contentHtml = `
    <html>
      <head>
        <style>
          body {
            font-family: Arial, sans-serif;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            margin: 0;
          }
          .container-qrcode {
            text-align: center;
          }
          .header-qrcode h1 {
            color: #000;
            font-size: 24px;
            margin: 0;
          }
          .qr-code {
            margin: 20px 0;
          }
          .qr-code img {
            width: 250px;
            height: 250px;
          }
        </style>
      </head>
      <body>
        <div class="div-qrcode">
     
          <div class="qr-code">
            <img id="qrImage" src="${qrCodeData}" alt="QR Code">
          </div>
        </div>
      </body>
    </html>
  `;


    const content: HTMLElement = document.createElement('div');

    content.innerHTML = `${contentHtml}`;

    // if (!isPlatform('mobileweb') && isPlatform('mobile')) {
    //   // Para impressão nativa no mobile
    //   Printer.print(content, { name: 'QR Code', orientation: 'portrait' });
    // } else {



    try {
      // Gera o QR code como base64
      //const qrCodeData = await QRCode.toDataURL(`https://xeguei.com.br/catalogo.html?parceiro=${loja.replaceAll("empresa#", "")}`);

      // Abre uma nova janela para imprimir o QR code
      const printWindow: any = window.open('', '_blank');

      // Escreve o HTML na nova janela
      // printWindow.document.write(`<html><head><title>Print QR Code</title></head><body>`);
      // printWindow.document.write(`<img id="qrImage" src="${qrCodeData}" alt="QR Code" />`);
      // printWindow.document.write(`</body></html>`);

      printWindow.document.write(contentHtml);

      printWindow.document.close();

      // Aguarda o carregamento completo da imagem antes de imprimir
      const qrImage = printWindow.document.getElementById('qrImage') as HTMLImageElement;
      qrImage.onload = function () {
        printWindow.focus();  // Foca a janela
        printWindow.print();  // Chama a função de impressão
        printWindow.close();  // Fecha a janela de impressão após imprimir
      };

    } catch (err) {
      console.error('Erro ao gerar ou imprimir o QR Code', err);
    }

    // }
  };


  const abrirNovoProduto = () => {
    if (listaCategoria.length === 0) {
      setTextToast('Crie as categorias primeiro para depois adicionar os itens ao seu catálogo.');
      setShowToast(true);
      return;
    }
    setIndice("");
    setNome("");
    setId("");
    setDescricao("");

    setGrupoComplementos([]);

    setFileArquivos(null);
    setFileDataURL(null);
    // atualizarTamanhoImagem();

    setInternet(true);
    setDestaque(false);
    setDisponibilidadeDeliveryDias([]);
    setControlarEstoque(false);
    setQuantidadeEstoque("");
    setQuantidadeMinEstoque("");
    setImpressoraSelecionada("");
    setCodigo("");
    setCategoria("");
    setValor("");
    setCusto("");
    setObjetoCategoria("");
    setValores([]);
    setCustos([]);
    setEtapa("1");
    setIsItemValid(false);
    setUnidadeMedida("unid");
    setShowDetalhes(true);
  }

  return (

    <IonPage className="ProdutosCatalogo">
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack();/*.replace("/empresa/operacoes", { recarregar: false }); */ }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Catálogo de produtos</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={openPopover}>
              <IonIcon slot="icon-only" icon={ellipsisVertical} />
            </IonButton>
          </IonButtons>

          <IonPopover
            isOpen={showPopover}
            event={popoverEvent}
            onDidDismiss={closePopover}
          >
            <IonList>
              {getButtons().map((button: any, index: number) => (
                <IonItem key={"popover" + index} lines="none" disabled={button.disabled} button onClick={() => {
                  if (button.handler) button.handler();
                  closePopover();
                }}>
                  <IonIcon icon={button.icon} slot="start" />
                  <IonLabel>{button.text}</IonLabel>
                </IonItem>
              ))}
            </IonList>
          </IonPopover>


        </IonToolbar>
        <OnboardingContextBanner />
        <IonToolbar>
          <IonGrid hidden={listaItemCatalogoProdutos.length === 0}>
            <IonRow style={{ alignItems: 'center' }}>

              {/* Busca */}
              <IonCol size="7" sizeMd="6">
                <IonSearchbar
                  placeholder="Buscar item"
                  value={busca}
                  onIonInput={(e) => setBusca(e.target.value!)}
                  debounce={500}
                />
              </IonCol>

              {/* Categoria */}
              <IonCol size="5" sizeMd="3">
                <IonSelect
                  value={categoriaSelecionada}
                  placeholder="Categorias"
                  onIonChange={(e) => setCategoriaSelecionada(e.detail.value)}
                >
                  <IonSelectOption value="">CATEGORIAS</IonSelectOption>

                  {listaCategoria.map((categoria: any, index: any) => (
                    <IonSelectOption key={index} value={categoria.nome}>
                      {categoria.nome}
                    </IonSelectOption>
                  ))}
                </IonSelect>
              </IonCol>

              {/* Botão somente no Desktop */}
              {isWeb && (
                <IonCol
                  size="12"
                  sizeMd="3"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <IonButton
                    fill="solid"
                    size="large"
                    color="tertiary"
                    onClick={() => abrirNovoProduto()}
                    hidden={acessos?.configuracoes != 'edicao'}
                  >
                    <IonIcon icon={add} slot="start" />
                    Novo produto
                  </IonButton>
                </IonCol>
              )}
            </IonRow>
          </IonGrid>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen={false}>
        {!isWeb && (
          <IonFab vertical="bottom" horizontal="center" slot="fixed" hidden={acessos?.configuracoes != 'edicao' || listaItemCatalogoProdutos.length === 0}>
            <IonFabButton color="tertiary" class="custom-fab-button" onClick={() => {
              abrirNovoProduto();
            }} >
              <IonIcon color="light" icon={add}></IonIcon>
            </IonFabButton>
          </IonFab>
        )}


        <IonList>

          {loadItemCatalogoProdutos()}



          {/* <IonFab horizontal="end" edge style={{ "top": "0px", "right": "-4px" }} hidden={acessos?.configuracoes != 'edicao'}>
            <IonFabButton size="small" color="tertiary" 
              <IonIcon color="light" icon={menu}></IonIcon>
            </IonFabButton>
          </IonFab> */}
        </IonList>


        {/* <IonButton slot="end" >Ordenar</IonButton> */}



        <IonModal className="fullscreen-modal" onDidPresent={() => {
          if (inputRef.current) {
            inputRef.current.setFocus();
          }
        }} isOpen={showDetalhes} onDidDismiss={() => {
          setShowDetalhes(false);
        }}>


          <>
            <IonHeader>
              <IonToolbar color="primary">
                <IonButtons slot="start">
                  <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowDetalhes(false)} />
                </IonButtons>
                <IonTitle>Novo item</IonTitle>
              </IonToolbar>
              <IonToolbar style={{ height: "48px" }} hidden={objetoCategoria?.tipo === "complementos"}>
                <IonSegment value={etapa} onIonChange={(e) => handleEtapaChange(e.detail.value)}>
                  <IonSegmentButton style={{ height: "30px" }} value="1">
                    <IonLabel style={{ fontSize: "14px" }}>Item</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton
                    style={{ height: "30px" }}
                    value="2"
                    className={!isItemValid ? "segment-button-disabled" : ""}
                  >
                    <IonLabel style={{ fontSize: "14px" }}>Complementos</IonLabel>
                  </IonSegmentButton>
                </IonSegment>
              </IonToolbar>
            </IonHeader>
            <IonContent>

              {etapa === '1' && (
                <div style={{ padding: '12px', background: '#fff' }}>

                  {/* ═══════════ SEÇÃO 1: INFORMAÇÕES BÁSICAS ═══════════ */}
                  <IonCard className="catalogo-form-card">
                    <IonCardContent style={{ padding: '16px' }}>
                      {/* Cabeçalho da seção */}
                      <div className="catalogo-section-header">
                        <div className="catalogo-section-icon" style={{ background: '#FFF3E0' }}>
                          <IonIcon icon={storefrontOutline} style={{ color: 'var(--ion-color-primary)', fontSize: '20px' }} />
                        </div>
                        <div>
                          <div className="catalogo-section-title">INFORMAÇÕES BÁSICAS</div>
                          <div className="catalogo-section-subtitle">Dados principais do item</div>
                        </div>
                      </div>

                      <div className="catalogo-info-basica-layout">
                        {/* Coluna esquerda: campos de texto */}
                        <div className="catalogo-info-basica-fields">
                          {/* Nome */}
                          <div className="catalogo-field">
                            <label className="catalogo-field-label">Nome*</label>
                            <IonInput
                              className="catalogo-field-input"
                              placeholder="Digite o nome"
                              value={nome}
                              ref={(ref) => inputRef.current = ref}
                              autoCorrect='true' autoCapitalize='true'
                              required
                              onIonInput={(e: any) => setNome(e.target.value)}
                            />
                          </div>

                          {/* Descrição */}
                          <div className="catalogo-field">
                            <label className="catalogo-field-label">Descrição</label>
                            <IonInput
                              className="catalogo-field-input"
                              placeholder="Digite a descrição"
                              value={descricao}
                              autoCorrect='true' autoCapitalize='true'
                              required
                              onIonInput={(e: any) => setDescricao(e.target.value)}
                            />
                          </div>

                          <div className="catalogo-field">
                            <label className="catalogo-field-label">Código</label>
                            <IonInput
                              className="catalogo-field-input"
                              placeholder="Digite o código"
                              value={codigo}
                              autoCorrect='true' autoCapitalize='true'
                              required
                              onIonInput={(e: any) => setCodigo(e.target.value)}
                            />
                          </div>

                          <div className="catalogo-field">
                            <label className="catalogo-field-label">Categoria*</label>
                            <IonSelect
                              className="catalogo-field-input"
                              value={categoria}
                              placeholder="Selecione"
                              onIonChange={e => {
                                setCategoria(e.detail.value);

                                let found;
                                found = listaCategoria.find((obj: any) => {
                                  return obj.nome === e.detail.value;
                                });

                                console.log("found", found);
                                setObjetoCategoria(found);

                                if (found?.tipo === "complementos") {
                                  setGrupoComplementos([]);
                                  if (etapa === '2') {
                                    setEtapa('1');
                                  }
                                }

                                if (found?.tipo == "pizzas") {
                                  setPizzaFormState(found);
                                  setValor("");
                                } else {
                                  setValores([]);
                                  setCustos([]);
                                }
                              }}
                            >
                              {readCategoria()}
                            </IonSelect>
                          </div>
                        </div>

                        {/* Coluna direita: imagem */}
                        <div className="catalogo-info-basica-image">
                          <label className="catalogo-field-label">Imagem</label>
                          <div
                            className="catalogo-image-dropzone catalogo-image-dropzone--tall"
                            onClick={() => inputUploadArquivoRef.current?.click()}
                          >
                            {fileDataURL && fileDataURL !== imgDefaultImage ? (
                              <div className="catalogo-image-preview">
                                <img src={fileDataURL} alt="Imagem do item" />
                              </div>
                            ) : (
                              <>
                                <div className="catalogo-image-dropzone-icon">
                                  <IonIcon icon={cameraOutline} style={{ fontSize: '32px', color: 'var(--ion-color-primary)' }} />
                                </div>
                                <span style={{ fontWeight: 600, fontSize: '14px', color: '#333' }}>Adicionar imagem</span>
                                <span style={{ fontSize: '12px' }}>Selecione para adicionar uma imagem</span>
                                <span style={{ fontSize: '11px', color: '#bbb' }}>PNG, JPG até 5MB</span>
                              </>
                            )}
                            <input
                              ref={inputUploadArquivoRef}
                              onChange={ChangeHandlerInputFile}
                              type="file"
                              accept="image/*"
                              style={{ display: 'none' }}
                            />
                          </div>
                        </div>
                      </div>
                    </IonCardContent>
                  </IonCard>


                  {/* ═══════════ SEÇÃO 2: PREÇO E CUSTO ═══════════ */}
                  <IonCard className="catalogo-form-card">
                    <IonCardContent style={{ padding: '16px' }}>
                      <div className="catalogo-section-header">
                        <div className="catalogo-section-icon" style={{ background: '#E8F5E9' }}>
                          <IonIcon icon={cashOutline} style={{ color: '#2E7D32', fontSize: '20px' }} />
                        </div>
                        <div>
                          <div className="catalogo-section-title">PREÇO E CUSTO</div>
                          <div className="catalogo-section-subtitle">Defina o valor de venda, custo e unidade</div>
                        </div>
                      </div>

                      {(objetoCategoria && objetoCategoria.tipo == "pizzas") ? (
                        <>
                          {objetoCategoria.tamanhos.map((size: any, index: any) => (
                            <IonGrid key={"tam" + index} style={{ padding: 0 }}>
                              <IonRow>
                                <IonCol size="6" style={{ paddingLeft: 0 }}>
                                  <div className="catalogo-field">
                                    <label className="catalogo-field-label">Valor {size.name}*</label>
                                    <IonInput
                                      className="catalogo-field-input"
                                      type="tel"
                                      maxlength={14}
                                      placeholder="Digite o valor"
                                      value={valores[index] || ''}
                                      onIonChange={(e: any) => onChangeValorArray(e, index)}
                                    />
                                  </div>
                                </IonCol>
                                <IonCol size="6" style={{ paddingRight: 0 }}>
                                  <div className="catalogo-field">
                                    <label className="catalogo-field-label">Custo {size.name}</label>
                                    <IonInput
                                      className="catalogo-field-input"
                                      type="tel"
                                      maxlength={14}
                                      placeholder="Custo unitário"
                                      value={custos[index] || ''}
                                      onIonChange={(e: any) => onChangeCustoArray(e, index)}
                                    />
                                  </div>
                                </IonCol>
                              </IonRow>
                            </IonGrid>
                          ))}
                        </>
                      ) : (
                        <IonGrid style={{ padding: 0 }}>
                          <IonRow>
                            <IonCol size="6" style={{ paddingLeft: 0 }}>
                              <div className="catalogo-field">
                                <label className="catalogo-field-label">Valor*</label>
                                <IonInput className="catalogo-field-input" type="tel" maxlength={14} placeholder="Digite o valor" value={valor}
                                  onKeyUp={onChangeValor} />
                              </div>
                            </IonCol>
                            <IonCol size="6" style={{ paddingRight: 0 }}>
                              <div className="catalogo-field">
                                <label className="catalogo-field-label">Custo</label>
                                <IonInput className="catalogo-field-input" type="tel" maxlength={14} placeholder="Custo unitário" value={custo}
                                  onKeyUp={onChangeCusto} />
                              </div>
                            </IonCol>
                          </IonRow>
                        </IonGrid>
                      )}

                      <div className="catalogo-field">
                        <label className="catalogo-field-label">Unidade de medida*</label>
                        <IonSelect
                          className="catalogo-field-input"
                          value={unidadeMedida}
                          placeholder="Selecione"
                          onIonChange={e => { setUnidadeMedida(e.detail.value); }}
                        >
                          <IonSelectOption key="kg" value="kg">Quilograma (kg)</IonSelectOption>
                          <IonSelectOption key="m" value="m">Metro (m)</IonSelectOption>
                          <IonSelectOption key="m2" value="m2">Metro (m²)</IonSelectOption>
                          <IonSelectOption key="unid" value="unid">Unidade (unid)</IonSelectOption>
                        </IonSelect>
                      </div>
                    </IonCardContent>
                  </IonCard>


                  {/* ═══════════ SEÇÃO 3: CONFIGURAÇÕES ═══════════ */}
                  <IonCard className="catalogo-form-card">
                    <IonCardContent style={{ padding: '16px' }}>
                      <div className="catalogo-section-header">
                        <div className="catalogo-section-icon" style={{ background: '#F3F4F6' }}>
                          <IonIcon icon={cogOutline} style={{ color: '#6B7280', fontSize: '20px' }} />
                        </div>
                        <div>
                          <div className="catalogo-section-title">CONFIGURAÇÕES</div>
                          <div className="catalogo-section-subtitle">Opções de exibição, estoque, fiscal e impressão</div>
                        </div>
                      </div>

                      {/* ─── Sub: EXIBIÇÃO NO CARDÁPIO ─── */}
                      {/* <div className="catalogo-subsection-header">
                        <div className="catalogo-subsection-icon">
                          <IonIcon icon={bookOutline} style={{ color: 'var(--ion-color-primary)', fontSize: '16px' }} />
                        </div>
                        <div>
                          <div className="catalogo-subsection-title">EXIBIÇÃO NO CARDÁPIO</div>
                          <div className="catalogo-subsection-subtitle">Como o item aparece para seus clientes</div>
                        </div>
                      </div> */}

                      <div className="catalogo-toggle-row">
                        <div style={{ flex: 1 }}>
                          <div className="catalogo-toggle-label">Exibir no catálogo digital</div>
                          <div className="catalogo-toggle-desc">Visível para clientes no cardápio online</div>
                        </div>
                        <IonToggle
                          checked={internet}
                          onIonChange={(e: any) => setInternet(e.detail.checked)}

                        />
                      </div>

                      {/* {internet && (
                        <div className="catalogo-info-chip catalogo-info-chip--success">
                          <IonIcon icon={informationCircleOutline} style={{ fontSize: '16px', marginRight: '6px', color: '#2E7D32' }} />
                          Item disponível para venda no catálogo digital.
                        </div>
                      )} */}

                      {internet && (
                        <>
                          <div className="catalogo-dias-card">
                            <div className="catalogo-dias-card-header">
                              <div className="catalogo-dias-card-icon">
                                <IonIcon icon={calendarOutline} />
                              </div>
                              <div style={{ flex: 1 }}>
                                <div className="catalogo-dias-card-title">
                                  Dias disponíveis no delivery
                                  <span className="catalogo-dias-badge-novo">NOVO</span>
                                </div>
                                <div className="catalogo-dias-card-desc">Selecione os dias em que este item estará visível no catálogo digital. Se nenhum for selecionado, ficará disponível todos os dias.</div>
                              </div>
                            </div>
                            <div className="catalogo-dias-chips">
                              {[
                                { label: 'Dom', value: 0 },
                                { label: 'Seg', value: 1 },
                                { label: 'Ter', value: 2 },
                                { label: 'Qua', value: 3 },
                                { label: 'Qui', value: 4 },
                                { label: 'Sex', value: 5 },
                                { label: 'Sáb', value: 6 },
                              ].map((dia) => {
                                const selecionado = disponibilidadeDeliveryDias.includes(dia.value);
                                return (
                                  <button
                                    key={dia.value}
                                    className={`catalogo-dia-chip${selecionado ? ' catalogo-dia-chip--ativo' : ''}`}
                                    onClick={() => {
                                      setDisponibilidadeDeliveryDias((prev) =>
                                        selecionado
                                          ? prev.filter((d) => d !== dia.value)
                                          : [...prev, dia.value].sort()
                                      );
                                    }}
                                  >
                                    {dia.label}
                                  </button>
                                );
                              })}
                            </div>
                          </div>

                          {/* {disponibilidadeDeliveryDias.length > 0 && ( */}
                          <div className="catalogo-dias-card" style={{ marginTop: '12px' }}>
                            <div className="catalogo-dias-card-header">
                              <div className="catalogo-dias-card-icon">
                                <IonIcon icon={timeOutline} />
                              </div>
                              <div style={{ flex: 1 }}>
                                <div className="catalogo-dias-card-title">
                                  Horários disponíveis
                                  <span className="catalogo-dias-badge-novo">NOVO</span>
                                </div>
                                <div className="catalogo-dias-card-desc">Defina faixas de horário em que o item estará visível. Se nenhuma for adicionada, ficará disponível o dia inteiro.</div>
                              </div>
                            </div>

                            {disponibilidadeDeliveryHorarios.map((faixa, idx) => (
                              <IonGrid key={idx} style={{ padding: '0' }}>
                                <IonRow style={{ alignItems: 'center' }}>
                                  <IonCol size="4" style={{ paddingLeft: 0 }}>
                                    <div className="catalogo-field">
                                      <label className="catalogo-field-label">Início</label>
                                      <IonInput
                                        className="catalogo-field-input"
                                        type="time"
                                        value={faixa.inicio}
                                        onIonChange={(e: any) => {
                                          const novo = [...disponibilidadeDeliveryHorarios];
                                          novo[idx] = { ...novo[idx], inicio: e.detail.value || '' };
                                          setDisponibilidadeDeliveryHorarios(novo);
                                        }}
                                      />
                                    </div>
                                  </IonCol>
                                  <IonCol size="4">
                                    <div className="catalogo-field">
                                      <label className="catalogo-field-label">Fim</label>
                                      <IonInput
                                        className="catalogo-field-input"
                                        type="time"
                                        value={faixa.fim}
                                        onIonChange={(e: any) => {
                                          const novo = [...disponibilidadeDeliveryHorarios];
                                          novo[idx] = { ...novo[idx], fim: e.detail.value || '' };
                                          setDisponibilidadeDeliveryHorarios(novo);
                                        }}
                                      />
                                    </div>
                                  </IonCol>
                                  <IonCol size="3" style={{ textAlign: 'center', paddingTop: '20px' }}>

                                  </IonCol>
                                  <IonCol size="1" style={{ textAlign: 'center', paddingTop: '20px' }}>
                                    <IonIcon
                                      icon={trashOutline}
                                      style={{ fontSize: '20px', color: '#eb445a', cursor: 'pointer' }}
                                      onClick={() => setDisponibilidadeDeliveryHorarios(prev => prev.filter((_, i) => i !== idx))}
                                    />
                                  </IonCol>
                                </IonRow>
                              </IonGrid>
                            ))}

                            <IonButton
                              expand="block"
                              fill="outline"
                              size="small"
                              style={{ marginTop: '8px' }}
                              onClick={() => {
                                const temVazio = disponibilidadeDeliveryHorarios.some(f => !f.inicio || !f.fim);
                                if (temVazio) {
                                  setTextToast('Preencha os campos de início e fim antes de adicionar outra faixa.');
                                  setShowToast(true);
                                  return;
                                }
                                setDisponibilidadeDeliveryHorarios(prev => [...prev, { inicio: '', fim: '' }]);
                              }}
                            >
                              <IonIcon icon={addOutline} slot="start" />
                              Adicionar faixa de horário
                            </IonButton>
                          </div>
                          {/* )} */}
                        </>
                      )}

                      <div className="catalogo-toggle-row">
                        <div style={{ flex: 1 }}>
                          <div className="catalogo-toggle-label">Exibir como destaque</div>
                          <div className="catalogo-toggle-desc">Aparece em destaque no cardápio</div>
                        </div>
                        <IonToggle
                          checked={destaque}
                          onIonChange={(e: any) => setDestaque(e.detail.checked)}

                        />
                      </div>

                      <div className="catalogo-config-divider" />

                      {/* ─── Sub: ESTOQUE ─── */}
                      <div className="catalogo-toggle-row">
                        <div className="catalogo-subsection-icon">
                          <IonIcon icon={cubeOutline} style={{ color: '#6B7280', fontSize: '16px' }} />
                        </div>
                        <div style={{ flex: 1 }}>
                          <div className="catalogo-subsection-title">ESTOQUE</div>
                          <div className="catalogo-subsection-subtitle">Gerencie a quantidade disponível</div>
                        </div>
                        <IonToggle
                          checked={controlarEstoque}
                          onIonChange={(e: any) => {
                            setControlarEstoque(e.detail.checked);
                            if (!e.detail.checked) {
                              setQuantidadeEstoque("");
                              setQuantidadeMinEstoque("");
                            }
                          }}

                        />
                      </div>

                      {controlarEstoque && (
                        <>
                          <div className="catalogo-info-chip catalogo-info-chip--info">
                            <IonIcon icon={informationCircleOutline} style={{ fontSize: '16px', marginRight: '6px', color: '#1565C0' }} />
                            Ao ativar o controle de estoque, você poderá definir a quantidade atual e o estoque mínimo.
                          </div>

                          <IonGrid style={{ padding: 0 }}>
                            <IonRow>
                              <IonCol size="6" style={{ paddingLeft: 0 }}>
                                <div className="catalogo-field">
                                  <label className="catalogo-field-label">Quantidade atual</label>
                                  <IonInput className="catalogo-field-input" type="tel" maxlength={14} placeholder="Ex: 25" value={quantidadeEstoque}
                                    onKeyUp={onChangeQuantidadeEstoque} />
                                </div>
                              </IonCol>
                              <IonCol size="6" style={{ paddingRight: 0 }}>
                                <div className="catalogo-field">
                                  <label className="catalogo-field-label">Estoque mínimo</label>
                                  <IonInput className="catalogo-field-input" type="tel" maxlength={14} placeholder="Ex: 5" value={quantidadeMinEstoque}
                                    onKeyUp={onChangeQuantidadeMinEstoque} />
                                </div>
                              </IonCol>
                            </IonRow>
                          </IonGrid>
                        </>
                      )}

                      {/* ─── Sub: FISCAL ─── */}
                      {listaFiscalCategorias.length > 0 && (
                        <>
                          <div className="catalogo-config-divider" />
                          <div className="catalogo-subsection-header">
                            <div className="catalogo-subsection-icon">
                              <IonIcon icon={documentTextOutline} style={{ color: '#6B7280', fontSize: '16px' }} />
                            </div>
                            <div>
                              <div className="catalogo-subsection-title">FISCAL</div>
                              <div className="catalogo-subsection-subtitle">Obrigatório para emissão de documentos fiscais</div>
                            </div>
                          </div>

                          <div className="catalogo-field">
                            <label className="catalogo-field-label">Categoria fiscal</label>
                            <IonSelect
                              className="catalogo-field-input"
                              value={fiscalCategoriaId}
                              placeholder="Selecione (opcional)"
                              onIonChange={e => { setFiscalCategoriaId(e.detail.value); }}
                            >
                              <IonSelectOption key="fiscal-nenhuma" value="">Nenhuma</IonSelectOption>
                              {listaFiscalCategorias.map((cat: any) => (
                                <IonSelectOption key={cat.id} value={cat.id}>
                                  {cat.nome} (NCM: {cat.ncm})
                                </IonSelectOption>
                              ))}
                            </IonSelect>
                          </div>
                        </>
                      )}

                      {/* ─── Sub: IMPRESSÃO ─── */}
                      {dadosEmpresa?.multiImpressao > 1 && (
                        <>
                          <div className="catalogo-config-divider" />
                          <div className="catalogo-subsection-header">
                            <div className="catalogo-subsection-icon">
                              <IonIcon icon={printOutline} style={{ color: '#6B7280', fontSize: '16px' }} />
                            </div>
                            <div>
                              <div className="catalogo-subsection-title">IMPRESSÃO</div>
                              <div className="catalogo-subsection-subtitle">Impressora utilizada para impressão do item</div>
                            </div>
                          </div>

                          <div className="catalogo-field">
                            <label className="catalogo-field-label">Impressora</label>
                            <IonSelect
                              className="catalogo-field-input"
                              value={impressoraSelecionada}
                              placeholder="Selecione a impressora"
                              onIonChange={e => setImpressoraSelecionada(e.detail.value)}
                            >
                              <IonSelectOption value="">Impressora Padrão</IonSelectOption>
                              {dadosEmpresa?.impressorasAdicionais?.map((impressora: any, index: number) => (
                                <IonSelectOption key={`impressora-${index}`} value={impressora.nome}>
                                  {impressora.nome}
                                </IonSelectOption>
                              ))}
                            </IonSelect>
                          </div>
                        </>
                      )}

                    </IonCardContent>
                  </IonCard>

                </div>
              )}

              {etapa === '2' && (
                <div style={{ padding: '12px', background: '#fff' }}>

                  <div
                    onClick={addGrupoComplementos}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '10px 4px', cursor: 'pointer', color: 'var(--ion-color-primary)', fontWeight: 600, fontSize: '14px' }}
                  >
                    <IonIcon icon={addOutline} style={{ fontSize: '18px' }} />
                    Adicionar grupo de complementos
                  </div>

                  {grupoComplementos?.map((grupo: any, groupIndex: any) => (
                    <div key={groupIndex}>

                      {/* ═══════════ CARD: DADOS DO GRUPO ═══════════ */}
                      <IonCard className="catalogo-form-card">
                        <IonCardContent style={{ padding: '16px' }}>
                          <div className="catalogo-section-header">
                            <div className="catalogo-section-icon" style={{ background: '#FFF3E0' }}>
                              <IonIcon icon={appsOutline} style={{ color: 'var(--ion-color-primary)', fontSize: '20px' }} />
                            </div>
                            <div style={{ flex: 1 }}>
                              <div className="catalogo-section-title">DADOS DO GRUPO</div>
                              <div className="catalogo-section-subtitle">Defina como será a escolha dos complementos</div>
                            </div>
                            <div
                              onClick={() => removeGrupoComplementos(groupIndex)}
                              style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer', color: '#ef4444', fontSize: '13px', fontWeight: 600 }}
                            >
                              <IonIcon icon={trashOutline} style={{ fontSize: '16px' }} />
                              Excluir
                            </div>
                          </div>

                          {/* Nome */}
                          <div className="catalogo-field">
                            <label className="catalogo-field-label">Nome do grupo de complementos</label>
                            <IonInput
                              className="catalogo-field-input"
                              ref={(ref) => contentNomeGrupoComplementoRef.current = ref}
                              value={grupo.name}
                              placeholder="ex: Acompanhamentos"
                              onIonInput={(e: any) => updateGrupoComplementos(groupIndex, 'name', e.target.value)}
                            />
                          </div>

                          <div className="catalogo-config-divider" />

                          {/* Obrigatoriedade */}
                          <div style={{ marginBottom: '14px' }}>
                            <div className="catalogo-field-label" style={{ fontWeight: 600, color: '#333', marginBottom: '2px' }}>Obrigatoriedade</div>
                            <div style={{ fontSize: '12px', marginBottom: '10px' }}>
                              Indique se a escolha de complementos é opcional ou obrigatória para completar o pedido.
                            </div>
                            <IonRadioGroup
                              value={grupo.obrigatoriedade}
                              onIonChange={e => {
                                updateGrupoComplementos(groupIndex, 'obrigatoriedade', e.detail.value);
                                if (grupo.obrigatoriedade == "opcional") {
                                  updateGrupoComplementos(groupIndex, 'sizeMin', 0);
                                } else {
                                  updateGrupoComplementos(groupIndex, 'sizeMin', 1);
                                }
                              }}
                            >
                              <div style={{ display: 'flex', gap: '24px' }}>
                                <div className="catalogo-radio-option">
                                  <IonRadio value="opcional" style={{ '--color-checked': 'var(--ion-color-primary)' } as any} />
                                  <span style={{ fontSize: '14px', color: '#333' }}>Opcional</span>
                                </div>
                                <div className="catalogo-radio-option">
                                  <IonRadio value="obrigatorio" style={{ '--color-checked': 'var(--ion-color-primary)' } as any} />
                                  <span style={{ fontSize: '14px', color: '#333' }}>Obrigatório</span>
                                </div>
                              </div>
                            </IonRadioGroup>
                          </div>

                          <div className="catalogo-config-divider" />

                          {/* ── Quantidade ── */}
                          <div style={{ marginBottom: '16px' }}>
                            <div className="catalogo-field-label" style={{ fontWeight: 600, color: '#333', marginBottom: '2px' }}>Quantidade</div>
                            <div style={{ fontSize: '12px', marginBottom: '4px' }}>
                              Indique quantos complementos devem ser selecionados no pedido.
                            </div>

                            <IonGrid>
                              <IonRow>
                                <IonCol size="4">
                                  <IonLabel>Mínimo</IonLabel>
                                </IonCol>

                                <IonCol size="4">
                                  <IonLabel>Máximo</IonLabel>
                                </IonCol>
                              </IonRow>

                              <IonRow>
                                <IonCol size="4">

                                  <IonChip style={{ margin: 0, padding: '5px' }}>
                                    <IonIcon
                                      size='large'
                                      color='danger'
                                      icon={removeCircle}
                                      onClick={() => {
                                        const sizeMinFormatado = parseFloat(grupo.sizeMin.toString().replace(/\./g, '').replace(/\,/g, '.'));
                                        if (sizeMinFormatado > 0 && grupo.obrigatoriedade == "opcional") {
                                          let sizeMinNovo = sizeMinFormatado - 1;
                                          updateGrupoComplementos(groupIndex, 'sizeMin', sizeMinNovo.toLocaleString('pt-br', {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                          }));
                                        }
                                        else if (sizeMinFormatado > 1 && grupo.obrigatoriedade == "obrigatorio") {
                                          let sizeMinNovo = sizeMinFormatado - 1;
                                          updateGrupoComplementos(groupIndex, 'sizeMin', sizeMinNovo.toLocaleString('pt-br', {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                          }));
                                        }


                                      }}
                                    />
                                    <IonLabel style={{ fontSize: '20px' }}>
                                      {grupo.sizeMin.toLocaleString('pt-br', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0
                                      })}
                                    </IonLabel>
                                    <IonIcon
                                      size='large'
                                      color='success'
                                      icon={addCircle}
                                      onClick={() => {
                                        const sizeMinFormatado = parseFloat(grupo.sizeMin.toString().replace(/\./g, '').replace(/\,/g, '.'));

                                        const sizeMaxFormatado = parseFloat(grupo.sizeMax.toString().replace(/\./g, '').replace(/\,/g, '.'));
                                        if (sizeMaxFormatado > sizeMinFormatado) {

                                          let sizeMinNovo = sizeMinFormatado + 1;
                                          updateGrupoComplementos(groupIndex, 'sizeMin', sizeMinNovo.toLocaleString('pt-br', {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                          }));
                                        }
                                      }}
                                    />
                                  </IonChip>
                                </IonCol>

                                <IonCol size="4">

                                  <IonChip style={{ margin: 0, padding: '5px' }}>
                                    <IonIcon
                                      size='large'
                                      color='danger'
                                      icon={removeCircle}
                                      onClick={() => {
                                        const sizeMaxFormatado = parseFloat(grupo.sizeMax.toString().replace(/\./g, '').replace(/\,/g, '.'));
                                        if (sizeMaxFormatado > 1) {
                                          const sizeMinFormatado = parseFloat(grupo.sizeMin.toString().replace(/\./g, '').replace(/\,/g, '.'));

                                          if (sizeMaxFormatado > sizeMinFormatado) {
                                            let sizeMaxNovo = sizeMaxFormatado - 1;
                                            updateGrupoComplementos(groupIndex, 'sizeMax', sizeMaxNovo.toLocaleString('pt-br', {
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0
                                            }));
                                          }
                                        }
                                      }}
                                    />
                                    <IonLabel style={{ fontSize: '20px' }}>
                                      {grupo.sizeMax.toLocaleString('pt-br', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0
                                      })}
                                    </IonLabel>
                                    <IonIcon
                                      size='large'
                                      color='success'
                                      icon={addCircle}
                                      onClick={() => {
                                        const sizeMaxFormatado = parseFloat(grupo.sizeMax.toString().replace(/\./g, '').replace(/\,/g, '.'));
                                        let sizeMaxNovo = sizeMaxFormatado + 1;
                                        updateGrupoComplementos(groupIndex, 'sizeMax', sizeMaxNovo);
                                      }}
                                    />
                                  </IonChip>
                                </IonCol>
                              </IonRow>

                            </IonGrid>
                          </div>
                          <div className="catalogo-config-divider" />

                          <div className="catalogo-section-header" style={{ marginTop: '4px' }}>
                            <div className="catalogo-section-icon" style={{ background: '#FFF3E0' }}>
                              <IonIcon icon={bagHandleOutline} style={{ color: 'var(--ion-color-primary)', fontSize: '20px' }} />
                            </div>
                            <div>
                              <div className="catalogo-section-title">ITENS DO COMPLEMENTO</div>
                              <div className="catalogo-section-subtitle">Adicione itens sem vínculo ou selecione produtos cadastrados como complementos</div>
                            </div>
                          </div>

                          <div className="catalogo-info-chip catalogo-info-chip--info">
                            <IonIcon icon={informationCircleOutline} style={{ fontSize: '18px', marginRight: '8px', color: '#1565C0', flexShrink: 0 }} />
                            <div>
                              O preço será considerado como um adicional ao item principal.
                              Se não houver valor adicional, considere R$ 0,00.
                            </div>
                          </div>

                          {/* Dois cards lado a lado: Criar novo / Selecionar existente */}
                          <IonGrid style={{ padding: 0, marginBottom: '16px' }}>
                            <IonRow>
                              <IonCol size="6" style={{ paddingLeft: 0 }}>
                                <div
                                  className="catalogo-action-card catalogo-action-card--dashed"
                                  onClick={() => addItem(groupIndex)}
                                >
                                  <div className="catalogo-action-card-icon" style={{ background: '#FFF3E0' }}>
                                    <IonIcon icon={addOutline} style={{ fontSize: '26px', color: 'var(--ion-color-primary)' }} />
                                  </div>
                                  <div className="catalogo-action-card-title" style={{ color: 'var(--ion-color-primary)' }}>Criar novo item</div>
                                  <div className="catalogo-action-card-desc">Item exclusivo deste grupo, sem vínculo com estoque.</div>
                                </div>
                              </IonCol>
                              {listaItemCatalogoProdutos?.some((value: any) => value.tipo === "complementos") && (
                                <IonCol size="6" style={{ paddingRight: 0 }}>
                                  <div
                                    className="catalogo-action-card catalogo-action-card--dashed"
                                    onClick={() => {
                                      selectComplementoRefs.current[groupIndex]?.open();
                                    }}
                                  >
                                    <div className="catalogo-action-card-icon" style={{ background: '#FFF3E0' }}>
                                      <IonIcon icon={searchOutline} style={{ fontSize: '26px', color: 'var(--ion-color-primary)' }} />
                                    </div>
                                    <div className="catalogo-action-card-title" style={{ color: 'var(--ion-color-primary)' }}>Selecionar item</div>
                                    <div className="catalogo-action-card-desc">Usar um item cadastrado com categoria tipo complementos.</div>
                                  </div>
                                  <IonSelect
                                    ref={(el) => { selectComplementoRefs.current[groupIndex] = el; }}
                                    style={{ display: 'none' }}
                                    value={itemCatalogoParaComplementos}
                                    placeholder="Selecione"
                                    onIonChange={(e) => {
                                      const selectedId = e.detail.value;
                                      if (selectedId && selectedId !== 'addItem') {
                                        const found = listaItemCatalogoProdutos.find((obj: any) => obj.id === selectedId);
                                        if (found) {
                                          selectedItem(groupIndex, found.id, found.nome, found.nomeImagem, found.tipoImagem, found.urlImagem, found.valor, found.custo, found.descricao);
                                        }
                                        setItemCatalogoParaComplementos("");
                                      }
                                    }}
                                  >
                                    {readCatalogo()}
                                  </IonSelect>
                                </IonCol>
                              )}
                            </IonRow>
                          </IonGrid>

                          {/* ═══════════ LISTA DE ITENS ═══════════ */}
                          {grupo.itens?.length > 0 && (
                            <div style={{
                              border: '1px solid #e0e0e0',
                              borderRadius: '10px',
                              overflow: 'hidden',
                            }}>

                              {/* Cabeçalho fixo das colunas */}
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                padding: '8px 12px',
                                background: '#f9f9f9',
                                borderBottom: '1px solid #e0e0e0',
                              }}>
                                <div style={{ flex: 1, fontSize: '11px' }}>
                                  Nome do item*
                                </div>
                                <div style={{ width: '72px', textAlign: 'right', fontSize: '11px' }}>Preço*</div>
                                <div style={{ width: '1px', height: '14px', background: '#ddd', flexShrink: 0 }} />
                                <div style={{ width: '72px', textAlign: 'right', fontSize: '11px' }}>Custo</div>
                                <div style={{ width: '32px' }} />
                              </div>

                              {grupo.itens.map((item: any, itemIndex: any) => (
                                <div
                                  key={itemIndex}
                                  style={{
                                    borderBottom: itemIndex < grupo.itens.length - 1 ? '1px solid #f0f0f0' : 'none',
                                    background: '#fff',
                                  }}
                                >
                                  {/* Linha principal: Nome + Preço + Custo + Lixeira */}
                                  <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '10px 12px 4px 12px',
                                  }}>
                                    {/* Nome */}
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                      <IonInput
                                        disabled={item.id ? true : false}
                                        value={item.name}
                                        placeholder="Ex: Batata frita"
                                        style={{
                                          '--padding-start': '0',
                                          '--padding-top': '0',
                                          '--padding-bottom': '0',
                                          fontSize: '14px',
                                          color: '#333',
                                        } as any}
                                        onIonInput={(e: any) => updateItem(groupIndex, itemIndex, 'name', e.target.value)}
                                      />
                                    </div>

                                    {/* Preço */}
                                    <div style={{ width: '72px', flexShrink: 0 }}>
                                      <IonInput
                                        disabled={item.id ? true : false}
                                        type="tel"
                                        maxlength={14}
                                        placeholder="0,00"
                                        value={item.price || ''}
                                        style={{
                                          '--padding-start': '6px',
                                          '--padding-end': '6px',
                                          '--padding-top': '6px',
                                          '--padding-bottom': '6px',
                                          fontSize: '13px',
                                          textAlign: 'right',
                                          border: '1px solid #e0e0e0',
                                          borderRadius: '6px',
                                          background: '#fff',
                                        } as any}
                                        onIonChange={(e: any) => onChangeValorItemArray(e, groupIndex, itemIndex)}
                                      />
                                    </div>

                                    {/* Divisor vertical */}
                                    <div style={{ width: '1px', height: '32px', background: '#e0e0e0', flexShrink: 0 }} />

                                    {/* Custo */}
                                    <div style={{ width: '72px', flexShrink: 0 }}>
                                      <IonInput
                                        disabled={item.id ? true : false}
                                        type="tel"
                                        maxlength={14}
                                        placeholder="0,00"
                                        value={item.custo || ''}
                                        style={{
                                          '--padding-start': '6px',
                                          '--padding-end': '6px',
                                          '--padding-top': '6px',
                                          '--padding-bottom': '6px',
                                          fontSize: '13px',
                                          textAlign: 'right',
                                          border: '1px solid #e0e0e0',
                                          borderRadius: '6px',
                                          background: '#fff',
                                        } as any}
                                        onIonChange={(e: any) => onChangeCustoItemArray(e, groupIndex, itemIndex)}
                                      />
                                    </div>

                                    {/* Lixeira */}
                                    <div style={{
                                      width: '32px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      flexShrink: 0,
                                    }}>
                                      <IonIcon
                                        icon={trashOutline}
                                        onClick={() => removeItem(groupIndex, itemIndex)}
                                        style={{ fontSize: '17px', color: '#ef4444', cursor: 'pointer' }}
                                      />
                                    </div>
                                  </div>

                                  {/* Descrição (opcional) */}
                                  <div style={{ padding: '0 12px 10px 12px' }}>
                                    <IonTextarea
                                      disabled={item.id ? true : false}
                                      value={item.description || ''}
                                      placeholder="Descrição (opcional)"
                                      maxlength={150}
                                      autoGrow={true}
                                      rows={1}
                                      style={{
                                        '--padding-start': '0',
                                        '--padding-end': '0',
                                        '--padding-top': '0',
                                        '--padding-bottom': '0',
                                        // fontSize: '12px',
                                        color: '#000',
                                      } as any}
                                      onIonInput={(e: any) => updateItem(groupIndex, itemIndex, 'description', e.target.value)}
                                    />
                                  </div>
                                </div>
                              ))}

                            </div>
                          )}

                        </IonCardContent>
                      </IonCard>

                    </div>
                  ))}
                </div>
              )}
            </IonContent>
            <IonFooter className="ion-no-border" hidden={etapa != '1'}>
              <IonToolbar>
                <IonButton
                  onClick={() => objetoCategoria?.tipo === "complementos" ? salvar() : handleEtapaChange('2')}
                  expand="block"
                  type="submit"
                >
                  {objetoCategoria?.tipo === "complementos" ? "Cadastrar" : "Avançar"}
                </IonButton>
              </IonToolbar>
            </IonFooter>

            <IonFooter className="ion-no-border" hidden={etapa != '2'}>
              <IonToolbar>
                <IonButton onClick={() => salvar()} expand="block" type="submit">Cadastrar</IonButton>
              </IonToolbar>
            </IonFooter>
          </>

        </IonModal>



        {/* Modal para visualizar o QR Code */}
        <IonModal isOpen={showModalQrCode} onDidDismiss={() => {
          setShowModalQrCode(false);
        }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonButtons slot="start">
                <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowModalQrCode(false)} />
              </IonButtons>
              <IonTitle>QRCode</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent class="ion-padding">
            <div className="div-qrcode">
              <div className="qr-code">
                {qrCodeData && <img src={qrCodeData} alt="QR Code" />}
              </div>
              <div className="copy-code-catalogo-prod">
                {/* Substituído por IonTextarea */}
                {qrCode}
                <IonButton fill="clear" onClick={() => {
                  navigator.clipboard.writeText(qrCode);
                  setTextToast("Catálogo copiado com sucesso.");
                  setShowToast(true);
                }}>
                  <IonIcon color="primary" icon={copy} />
                </IonButton>
              </div>

            </div>
          </IonContent>

          <IonFooter className="ion-no-border" >
            <IonToolbar>
              <IonButton expand="block" size='large' hidden={!isPlatform('mobileweb') && isPlatform('mobile')} onClick={() => { handlePrint(); }}>Imprimir</IonButton>
            </IonToolbar>
          </IonFooter>

        </IonModal>

        {/* Modal para visualizar o Catálogo Delivery */}
        <IonModal isOpen={showModalCatalogoDelivery} onDidDismiss={() => {
          setShowModalCatalogoDelivery(false);
        }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonButtons slot="start">
                <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowModalCatalogoDelivery(false)} />
              </IonButtons>
              <IonTitle>Catálogo Delivery</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent class="ion-padding">
            <div className="div-qrcode">
              <div className="copy-code-catalogo-prod">
                {/* Substituído por IonTextarea */}
                {catalogoDelivery}
                <IonButton fill="clear" onClick={() => {
                  navigator.clipboard.writeText(catalogoDelivery);
                  setTextToast("Catálogo copiado com sucesso.");
                  setShowToast(true);
                }}>
                  <IonIcon color="primary" icon={copy} />
                </IonButton>
              </div>
            </div>
          </IonContent>

        </IonModal>

        {/* Modal para visualizar a Cor do Catálogo Delivery */}
        <IonModal isOpen={showModalCorCatalogoDelivery} onDidDismiss={() => {
          setShowModalCorCatalogoDelivery(false);
        }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonButtons slot="start">
                <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowModalCorCatalogoDelivery(false)} />
              </IonButtons>
              <IonTitle>Cor do Catálogo Delivery</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent class="ion-padding">
            <div className="div-qrcode">
              <div style={{ marginTop: '24px', width: '100%' }}>
                <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#555' }}>Escolha uma cor para personalizar seu catálogo delivery.</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {paletteColors.map(c => (
                    <button
                      key={c}
                      onClick={() => { setCatalogColor(c); salvarCorCatalogo(c); }}
                      style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '8px',
                        border: c.toLowerCase() === catalogColor?.toLowerCase() ? '3px solid #3880ff' : '2px solid #ccc',
                        background: c,
                        cursor: 'pointer'
                      }}
                      aria-label={`Selecionar cor ${c}`}
                    />
                  ))}
                </div>

              </div>

            </div>
          </IonContent>

        </IonModal>


        {/* <IonModal onDidPresent={() => {
          if (inputUploadArquivoRef.current) {
            inputUploadArquivoRef.current.setFocus();
          }
        }} isOpen={showUploadArquivo} onDidDismiss={() => { setShowUploadArquivo(false); }}>
          <UploadArquivo accept="text/csv" inputRef={inputUploadArquivoRef} closeAction={closeModalUploadArquivoSucess} closeActionSimple={closeModalUploadArquivo}></UploadArquivo>
        </IonModal> */}


        <IonModal isOpen={showIfood} onDidDismiss={() => { setShowIfood(false); }}>
          <UploadIfood closeAction={closeModalIfoodSuccess} closeActionSimple={closeModalIfood}></UploadIfood>
        </IonModal>

        <IonModal isOpen={showAnotaAi} onDidDismiss={() => { setShowAnotaAi(false); }}>
          <UploadAnotaAi closeAction={closeModalAnotaAiSuccess} closeActionSimple={closeModalAnotaAi}></UploadAnotaAi>
        </IonModal>

        <IonModal isOpen={showYooga} onDidDismiss={() => { setShowYooga(false); }}>
          <UploadYooga closeAction={closeModalYoogaSuccess} closeActionSimple={closeModalYooga}></UploadYooga>
        </IonModal>

        <IonModal isOpen={showGoomer} onDidDismiss={() => { setShowGoomer(false); }}>
          <UploadGoomer closeAction={closeModalGoomerSuccess} closeActionSimple={closeModalGoomer}></UploadGoomer>
        </IonModal>

        <IonModal isOpen={showEcta} onDidDismiss={() => { setShowEcta(false); }}>
          <UploadEcta closeAction={closeModalEctaSuccess} closeActionSimple={closeModalEcta}></UploadEcta>
        </IonModal>

        <IonModal isOpen={showInstaDelivery} onDidDismiss={() => { setShowInstaDelivery(false); }}>
          <UploadInstaDelivery closeAction={closeModalInstaDeliverySuccess} closeActionSimple={closeModalInstaDelivery}></UploadInstaDelivery>
        </IonModal>

        <IonModal isOpen={showWhatsMenu} onDidDismiss={() => { setShowWhatsMenu(false); }}>
          <UploadWhatsMenu closeAction={closeModalWhatsMenuSuccess} closeActionSimple={closeModalWhatsMenu}></UploadWhatsMenu>
        </IonModal>

        <IonModal isOpen={showIA} onDidDismiss={() => { setShowIA(false); }}>
          <UploadIA closeAction={closeModalIASuccess} closeActionSimple={closeModalIA}></UploadIA>
        </IonModal>

        {/* <IonModal isOpen={showKivoPedidos} onDidDismiss={() => { setShowKivoPedidos(false); }}>
          <UploadKivoPedidos closeAction={closeModalKivoPedidosSuccess} closeActionSimple={closeModalKivoPedidos}></UploadKivoPedidos>
        </IonModal> */}

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

        {/* Action Sheet de Importação de Catálogos */}
        <IonActionSheet
          isOpen={showImportMenu}
          onDidDismiss={() => setShowImportMenu(false)}
          header="Importar catálogo"
          buttons={[
            {
              text: 'Importar por foto (IA)',
              icon: sparklesOutline,
              handler: () => {
                mostartAlerta({
                  backdropDismiss: false,
                  header: 'Importar com IA',
                  message: 'Você poderá enviar até 10 fotos do cardápio. A IA vai gerar uma <strong>prévia editável</strong> e, ao confirmar, o catálogo atual será <strong>substituído</strong>. Deseja continuar?',
                  buttons: [
                    {
                      text: 'Cancelar',
                      role: 'cancel',
                    },
                    {
                      text: 'Continuar',
                      cssClass: 'primary',
                      handler: () => {
                        setShowIA(true);
                      }
                    }
                  ],
                  onDidDismiss: (e) => console.log('did dismiss'),
                });
              }
            },
            {
              text: 'iFood',
              icon: downloadOutline,
              handler: () => {
                mostartAlerta({
                  backdropDismiss: false,
                  header: 'Importar Catálogo',
                  message: 'Todos os itens do catálogo serão <strong>excluídos</strong>. Deseja realmente continuar a importação?',
                  buttons: [
                    {
                      text: 'Cancelar',
                      role: 'cancel',
                    },
                    {
                      text: 'Confirmar',
                      cssClass: 'primary',
                      handler: () => {
                        setShowIfood(true);
                      }
                    }
                  ],
                  onDidDismiss: (e) => console.log('did dismiss'),
                });
              }
            },
            {
              text: 'Anota AI',
              icon: downloadOutline,
              handler: () => {
                mostartAlerta({
                  backdropDismiss: false,
                  header: 'Importar Anota AI',
                  message: 'Todos os itens do catálogo serão <strong>excluídos</strong>. Deseja realmente continuar a importação?',
                  buttons: [
                    {
                      text: 'Cancelar',
                      role: 'cancel',
                    },
                    {
                      text: 'Confirmar',
                      cssClass: 'primary',
                      handler: () => {
                        setShowAnotaAi(true);
                      }
                    }
                  ],
                  onDidDismiss: (e) => console.log('did dismiss'),
                });
              }
            },
            {
              text: 'Yooga',
              icon: downloadOutline,
              handler: () => {
                mostartAlerta({
                  backdropDismiss: false,
                  header: 'Importar Yooga',
                  message: 'Todos os itens do catálogo serão <strong>excluídos</strong>. Deseja realmente continuar a importação?',
                  buttons: [
                    {
                      text: 'Cancelar',
                      role: 'cancel',
                    },
                    {
                      text: 'Confirmar',
                      cssClass: 'primary',
                      handler: () => {
                        setShowYooga(true);
                      }
                    }
                  ],
                  onDidDismiss: (e) => console.log('did dismiss'),
                });
              }
            },
            {
              text: 'Goomer',
              icon: downloadOutline,
              handler: () => {
                mostartAlerta({
                  backdropDismiss: false,
                  header: 'Importar Goomer',
                  message: 'Todos os itens do catálogo serão <strong>excluídos</strong>. Deseja realmente continuar a importação?',
                  buttons: [
                    {
                      text: 'Cancelar',
                      role: 'cancel',
                    },
                    {
                      text: 'Confirmar',
                      cssClass: 'primary',
                      handler: () => {
                        setShowGoomer(true);
                      }
                    }
                  ],
                  onDidDismiss: (e) => console.log('did dismiss'),
                });
              }
            },
            {
              text: 'ECTA',
              icon: downloadOutline,
              handler: () => {
                mostartAlerta({
                  backdropDismiss: false,
                  header: 'Importar ECTA',
                  message: 'Todos os itens do catálogo serão <strong>excluídos</strong>. Deseja realmente continuar a importação?',
                  buttons: [
                    {
                      text: 'Cancelar',
                      role: 'cancel',
                    },
                    {
                      text: 'Confirmar',
                      cssClass: 'primary',
                      handler: () => {
                        setShowEcta(true);
                      }
                    }
                  ],
                  onDidDismiss: (e) => console.log('did dismiss'),
                });
              }
            },
            {
              text: 'InstaDelivery',
              icon: downloadOutline,
              handler: () => {
                mostartAlerta({
                  backdropDismiss: false,
                  header: 'Importar InstaDelivery',
                  message: 'Todos os itens do catálogo serão <strong>excluídos</strong>. Deseja realmente continuar a importação?',
                  buttons: [
                    {
                      text: 'Cancelar',
                      role: 'cancel',
                    },
                    {
                      text: 'Confirmar',
                      cssClass: 'primary',
                      handler: () => {
                        setShowInstaDelivery(true);
                      }
                    }
                  ],
                  onDidDismiss: (e) => console.log('did dismiss'),
                });
              }
            },
            {
              text: 'WhatsMenu',
              icon: downloadOutline,
              handler: () => {
                mostartAlerta({
                  backdropDismiss: false,
                  header: 'Importar WhatsMenu',
                  message: 'Todos os itens do catálogo serão <strong>excluídos</strong>. Deseja realmente continuar a importação?',
                  buttons: [
                    {
                      text: 'Cancelar',
                      role: 'cancel',
                    },
                    {
                      text: 'Confirmar',
                      cssClass: 'primary',
                      handler: () => {
                        setShowWhatsMenu(true);
                      }
                    }
                  ],
                  onDidDismiss: (e) => console.log('did dismiss'),
                });
              }
            },
            // {
            //   text: 'KivoPedidos',
            //   icon: downloadOutline,
            //   handler: () => {
            //     mostartAlerta({
            //       backdropDismiss: false,
            //       header: 'Importar KivoPedidos',
            //       message: 'Todos os itens do catálogo serão <strong>excluídos</strong>. Deseja realmente continuar a importação?',
            //       buttons: [
            //         {
            //           text: 'Cancelar',
            //           role: 'cancel',
            //         },
            //         {
            //           text: 'Confirmar',
            //           cssClass: 'primary',
            //           handler: () => {
            //             setShowKivoPedidos(true);
            //           }
            //         }
            //       ],
            //       onDidDismiss: (e) => console.log('did dismiss'),
            //     });
            //   }
            // },
            {
              text: 'Cancelar',
              icon: closeOutline,
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            }
          ]}
        />

      </IonContent>

    </IonPage >
  );


};

export default ProdutosCatalogo;